import { Component, ElementRef } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CustomerService } from '../../../../services/customer.service';
import { AdministratorService } from '../../../../services/administrator.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SalesService } from '../../../../services/sales.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Product, RecentInteractions, SalesOrder, UpdateInventory, gridPageRequest } from '../../../../model/common/common.model';
import { Warehouse } from '../../../../model/administration.model';
import { BillToCustomerLookupComponent } from '../../../Lookup/billtocustomer-lookup/billtocustomer-lookup.component';
import { ShipToCustomerLookupComponent } from '../../../Lookup/shiptocustomer-lookup/shiptocustomer-lookup.component';
import { SalespersonLookupComponent } from '../../../Lookup/salesperson-lookup/salesperson-lookup.component';
import { salesPerson } from '../../../../model/masters.model';
import { TermscodeLookupComponent } from '../../../Lookup/termscode-lookup/termscode-lookup.component';
import _ from 'lodash';
import { InventoryService } from '../../../../services/inventory.service';
import { ListLinkedFilesLookupComponent } from '../../../Lookup/List-Linked-Files-lookup/list-linked-files.lookup.component';
import { POCommentsLookupComponent } from '../../../Lookup/pocomments-lookup/pocomments-lookup.component';
import { viewproductLookupComponent } from '../../../Lookup/viewproduct-lookup/viewproduct-lookup.component';
import { SpecificationLookupComponent } from '../../../Lookup/specification-lookup/specification-lookup.component';
import { ReportCenterService } from '../../../../services/report-center.service';
import { EmailTemplateService } from '../../../../services/email-template.service';
import { catchError, forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { formatDateDDMMYY } from '../../../../services/formatDateDDMMYY';
import { PaymentReceiptService } from '../../../../services/payment-receipt.service';
import { getISTDateWithCurrentTime } from '../../../../utils/date-utils';
import { PurchaseorderService } from '../../../../services/purchaseorder.service';
import { discountAmountFromPercent, round2 } from '../../../../shared/discount-percent.util';
import { ProjectBomLookupComponent } from '../../../Lookup/projectbom-lookup/projectbom-lookup.component';


@Component({
  selector: 'app-view-dispatch-sales-order',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './view-dispatch-sales-order.component.html',
  styleUrl: './view-dispatch-sales-order.component.scss'
})
export class ViewDispatchSalesOrderComponent {

  constructor(private router: Router, private messageService: MessageService, private customerService: CustomerService, private administratorService: AdministratorService,
    public dialogService: DialogService, public ref: DynamicDialogRef, private inventoryService: InventoryService, private salesService: SalesService, private el: ElementRef, private confirmationService: ConfirmationService,
    private route: ActivatedRoute, private reportService: ReportCenterService, private emailTemplateService: EmailTemplateService, private paymentService: PaymentReceiptService, private porderservice: PurchaseorderService) { }

  loader: boolean = false;
  isEdit: boolean = false;
  isIGST: boolean = false;
  submitted: boolean = false;
  activeIndex: number = 0;
  isEditingQuantity: boolean = false;
  isEditingWeight: boolean = false;
  deliveryDate: any | undefined;
  productId: any;
  customer: any;
  isBO: boolean = false;
  unitLabel: string = '';
  savePopupVisible: boolean = false;
  ReportPath: any;
  companyInfo: any = {};
  emailFromSystemConfig: string = '';
  Status: any;
  ShipmentDate: any;
  selectedCustomerName: string | null = null;
  customerEmail: any;
  selectedCustomerEmail: string | null = null;
  Data: any;
  salesOrderId: number | null = null;
  sendEmailOnInvoice: boolean = false;
  canSendEmail: boolean = false;
  autoSendEmail: boolean = false;
  NonTaxableTotal: number = 0.00;
  showRCM: boolean = false;
  isOpenStatus: boolean = false;
  canEdit: any;

  createOrderForm = new FormGroup({
    OrderNo: new FormControl('', Validators.required),
    manualEntry: new FormControl(false),
    BillToCustomerId: new FormControl('', Validators.required),
    ShipToCustomerId: new FormControl('', Validators.required),
    BillToCustomerCode: new FormControl('', Validators.required),
    ShipToCustomerCode: new FormControl('', Validators.required),
    BillToCustomer: new FormControl('', Validators.required),
    ShipToCustomer: new FormControl('', Validators.required),
    BillToCustomerAddress: new FormControl(''),
    ShipToCustomerAddress: new FormControl('', Validators.required),
    warehouse: new FormControl('', Validators.required),
    WareHouseId: new FormControl('', Validators.required),
    saleserson: new FormControl('', Validators.required),
    SalespersonCode: new FormControl('', Validators.required),
    SalespersonId: new FormControl('', Validators.required),
    CreatedBy: new FormControl('', Validators.required),
    // add product
    productId: new FormControl(''),
    productCode: new FormControl(''),
    productDescription: new FormControl(''),
    productQty: new FormControl(''),
    productData: new FormControl(''),

    ShipmentDate: new FormControl(),
    TermsCode: new FormControl(''),
    PaymentTermsId: new FormControl(),
    DispatchDocNo: new FormControl(''),
    MotorVehicalNo: new FormControl(),
    BillOfLading: new FormControl(),
    purchaseOrderNumber: new FormControl(),
    LRRRNo: new FormControl(),
    DispatchThrough: new FormControl(),
    // OrderType: new FormControl('Q'),

    BillToCustomerState: new FormControl(''),
    warehouseState: new FormControl(''),

    requestedDate: new FormControl(),
    orderDate: new FormControl(),
    deliveryNote: new FormControl(''),

    ReferenceNumber: new FormControl(),
    Destination: new FormControl(),
    TermsOfDelivery: new FormControl(),
    Status: new FormControl(),
    CustomerPODate: new FormControl(),
    expDeliveryDate: new FormControl(),
    driverContact: new FormControl('', [Validators.pattern(/^[0-9]{10}$/)]),
    driverName: new FormControl(),
    RateOnFreight: new FormControl(),
    DiscountAmount: new FormControl(0),
    FreightTotal: new FormControl(0),
    GSTOnFreight: new FormControl(),
    FinalTaxableAmt: new FormControl(0),

    //new
    warehouseStateCode: new FormControl(''),
    supplyType: new FormControl(''),
    isLUT: new FormControl(false),
    expTyp: new FormControl(''),
    isRCM: new FormControl(false),
    POS: new FormControl(''),
    POSDisplay: new FormControl(''),
    BillToCustomerStateCode: new FormControl(''),
    ShipToCustomerStateCode: new FormControl(''),
    ShipToCustomerState: new FormControl(''),
    projectBoMId: new FormControl(null),
    projectName: new FormControl(''),
    projectNo: new FormControl(''),
    FinancialYearId: new FormControl(),
  });

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }

  BillTocustomerList: any[] = [];
  ShipTocustomerList: any[] = [];
  warehouseDropdown: Warehouse[] = [];
  filterProductList: any[] = [];
  products: Product[] = [];    // Main product variable
  allProductData: Product[] = []; // Stores all product data even after deleting from the grid
  addProductData: any;        // Represents data for adding a new product
  selectedProduct: Product[] = [];   // // Stores data for deleted products
  deleteProductIds: any[] = [];
  BOproducts: Product[] = [];    // Back Order product list


  orderTotal: number = 0.00;
  weightTotal: number = 0.00;
  CGSTtotal: number = 0.00;
  SGSTtotal: number = 0.00;
  IGSTtotal: number = 0.00;
  SalesTaxTotal: number = 0.00;
  Taxable: number = 0.00;

  creditLimitExceeded: boolean = false;
  showCreditDetails: boolean = false;
  exceededAmount: number = 0.00;
  invoiceAmount: number = 0.00;
  totalOutstanding: number = 0.00;
  customerCreditLimit: number = 0.00;
  FinalTaxableAmt: number = 0.00;

  BODetails: any = {
    OrderTotal: 0,
    WeightTotal: 0,
    CGSTtotal: 0,
    SGSTtotal: 0,
    IGSTtotal: 0,
    SalesTaxTotal: 0,
    Taxable: 0,
  };

  ngOnInit(): void {
    document.title = 'View Dispatch';
    this.reOpen();
    this.getWarehouse();
    this.getSystemConfigDataForEmail();
    this.getCompanyDetails();
    this.createOrderForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
    const currentDate = new Date();
    this.deliveryDate = currentDate;
    this.inventoryService.getUnitByAppKey('unitNameLabel').subscribe((res: any) => {
      this.unitLabel = res?.data || 'Unit';
    });
    this.createOrderForm.get('DiscountAmount')?.valueChanges.subscribe(() => {
      this.calculateOrderTotal();
    });

    this.createOrderForm.get('GSTOnFreight')?.valueChanges.subscribe(() => {
      this.calculateOrderTotal();
    });

    this.createOrderForm.get('RateOnFreight')?.valueChanges.subscribe(() => {
      this.calculateFreightGST();
    });

    this.createOrderForm.get('FreightTotal')?.valueChanges.subscribe(() => {
      this.calculateFreightGST();
    });

  }

  statusDropdown = [
    { label: 'Ready to Pick - 70%', value: 'Ready to Pick - 70%' },
    { label: 'In Picking - 80%', value: 'In Picking - 80%' },
    { label: 'Picked - 85%', value: 'Picked - 85%' },
    { label: 'In Packing - 90%', value: 'In Packing - 90%' },
    { label: 'Dispatched - 100%', value: 'Dispatched - 100%' },
  ];

  selectedStatus: string | null = null;
  //selectedStatus: string = 'Ready To Pick';

  onStatusChange(event: any) {
    this.selectedStatus = event.value;
  }

  //  statusColors: { [key: string]: string } = {
  //   'Ready To Pick': '#28a745',
  //   'In Packing': '#007bff',
  //   'Picked': '#ff9800',
  //   'Packing': '#6f42c1',
  //   'Shipped': '#343a40',
  //   // 'Packing': '#6c757d',     
  //   // 'Shipped': '#343a40',       
  // };

  // getStatusColor(status: string): string {
  //   return this.statusColors[status] || 'black';
  // }

  get formControls() {
    return this.createOrderForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.createOrderForm.invalid) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please fill Required field' });
      isValid = false;
    }

    return isValid;
  }

  resetForm() {
    // const OrderNo = this.createOrderForm.controls.OrderNo.value;
    this.confirmationService.confirm({
      header: 'Reset',
      message: 'Reset will permanently delete all lines in the grid.',
      accept: () => {
        // this.createOrderForm.reset();
        // this.createOrderForm.controls.manualEntry.setValue(true);
        // this.createOrderForm.controls.CreatedBy.setValue(sessionStorage.getItem('username'));
        // this.createOrderForm.controls.OrderNo.setValue(OrderNo);
        // this.createOrderForm.controls.OrderType.setValue('Q');
        // this.products = [];
        this.deleteProduct(true);

      },
      reject: () => {
      }
    });

  }

  Cancel() {
    // if(this.isEdit){
    this.router.navigate(['/home/dispatchSalesOrder']);
    // }else{
    //   this.router.navigate(['/home']);
    // }
  }

  manualEntry() {
    const manualEntryValue = this.createOrderForm.controls.manualEntry.value;

    if (manualEntryValue === true) {
      this.createOrderForm.controls.OrderNo.setValue('');
    } else {
      this.getOrderNumber();
    }

  }

  getOrderNumber() {
    this.loader = true;
    this.salesService.autogenerateSalesOrderNumber().subscribe({
      next: (data: any) => {
        this.createOrderForm.controls.OrderNo.setValue(data);
        this.loader = false;
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });
  }

  checkOrderNumber() {
    if (!this.createOrderForm.controls.OrderNo.value) {
      return;
    }
    if (this.products.length > 0) {
      return;
    }
    if (!this.isEdit) {
      this.salesService.checkOrderNumber(this.createOrderForm.controls.OrderNo.value).subscribe(
        (data: any) => {
          if (data.success == true) {
            // console.log(data);
          } else {
            this.createOrderForm.controls.OrderNo.setValue('');
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
            this.createOrderForm.controls.manualEntry.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  validateSalesOrder(value: string, sendEmail: boolean = false) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    if (this.products.length < 1) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
      const productCodeAutoCompleteElement = this.el.nativeElement.querySelector('[formControlName="productCode"]');
      if (productCodeAutoCompleteElement) {
        productCodeAutoCompleteElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    this.createSalesOrder(value, false, sendEmail);
  }



  showBillToCustomerDialog() {
    const ref = this.dialogService.open(BillToCustomerLookupComponent, {
      header: 'Bill TO Customer List',
      width: '80%'
    });

    ref.onClose.subscribe((selectedCustomer: any) => {
      if (selectedCustomer) {
        this.createOrderForm.controls.BillToCustomerId.setValue(selectedCustomer.customerId);
        this.createOrderForm.controls.BillToCustomerCode.setValue(selectedCustomer.customerCode);
        this.createOrderForm.controls.BillToCustomer.setValue(selectedCustomer.customerName);
        this.createOrderForm.controls.BillToCustomerState.setValue(selectedCustomer.address.state);
        const address = `${selectedCustomer.address.addressLine1}, ${selectedCustomer.address.city, selectedCustomer.address.state}, ${selectedCustomer.address.country} ${selectedCustomer.address.zip}`;
        this.createOrderForm.controls.BillToCustomerAddress.setValue(address);
        this.selectedCustomerEmail = selectedCustomer.email;
        this.selectedCustomerName = selectedCustomer.customerName;
        this.getTermsByCustomer(selectedCustomer.customerCode);
        this.customerEmail = (selectedCustomer.email);

      }
    });
  }



  openShipToCustomerLookup() {
    const ref = this.dialogService.open(ShipToCustomerLookupComponent, {
      header: 'Ship To Customer List',
      width: '80%'
    });

    ref.onClose.subscribe((selectedCustomer: any) => {
      if (selectedCustomer) {
        this.createOrderForm.controls.ShipToCustomerId.setValue(selectedCustomer.customerId);
        this.createOrderForm.controls.ShipToCustomerCode.setValue(selectedCustomer.customerCode);
        this.createOrderForm.controls.ShipToCustomer.setValue(selectedCustomer.customerName);
        const address = `${selectedCustomer.address.addressLine1}, ${selectedCustomer.address.city, selectedCustomer.address.state}, ${selectedCustomer.address.country} ${selectedCustomer.address.zip}`;
        this.createOrderForm.controls.ShipToCustomerAddress.setValue(address);
      }
    });
  }

  autosearchBilltoCustomer(event: any) {
    this.salesService.autoSearchCustomer(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.BillTocustomerList = data;
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  setBillTo(data: any) {
    if (data.value) {
      this.createOrderForm.controls.BillToCustomerCode.setValue(data.value.customerCode);
      this.createOrderForm.controls.BillToCustomer.setValue(data.value.customerName);
      this.createOrderForm.controls.BillToCustomerId.setValue(data.value.customerId);
      const address = `${data.value.address.addressLine1}, ${data.value.address.city, data.value.address.state}, ${data.value.address.country} ${data.value.address.zip}`;
      this.createOrderForm.controls.BillToCustomerAddress.setValue(address);
      this.createOrderForm.controls.BillToCustomerState.setValue(data.value.address.state);
    }
  }

  autosearchShiptoCustomer(event: any) {
    this.salesService.autoSearchCustomer(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.ShipTocustomerList = data.filter((customer: any) => customer.isShipToCustomer === true);
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  setShipTo(data: any) {
    if (data.value) {
      this.createOrderForm.controls.ShipToCustomerCode.setValue(data.value.customerCode);
      this.createOrderForm.controls.ShipToCustomer.setValue(data.value.customerName);
      this.createOrderForm.controls.ShipToCustomerId.setValue(data.value.customerId);
      const address = `${data.value.address.addressLine1}, ${data.value.address.city, data.value.address.state}, ${data.value.address.country} ${data.value.address.zip}`;
      this.createOrderForm.controls.ShipToCustomerAddress.setValue(address);
    }
  }

  getWarehouse() {
    this.administratorService.getAllWarehouse(this.pageRequest).subscribe({
      next: (data: any) => {
        this.warehouseDropdown = data.warehouses;
        // console.log(data);
      },
      error: error => {
        console.log(error);
      }
    });
  }

  setWarehouse(data: any) {
    if (data.value) {
      this.createOrderForm.controls.WareHouseId.setValue(data.value.warehouseId);
      this.createOrderForm.controls.warehouseState.setValue(data.value.address.state);
    }
  }

  showSalesperson() {
    this.ref = this.dialogService.open(SalespersonLookupComponent, {
      header: 'Salesperson List',
      width: '60%',

    });
    this.ref.onClose.subscribe((data: salesPerson) => {
      if (data) {
        this.createOrderForm.controls.SalespersonCode.setValue(data.salespersonCode);
        this.createOrderForm.controls.SalespersonId.setValue(_.toString(data.salespersonId));
      }
    });
  }

  showTermsCode() {
    this.ref = this.dialogService.open(TermscodeLookupComponent, {
      header: 'Terms Code',
      width: '60%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.createOrderForm.patchValue({
          TermsCode: data.paymentTermsDescription,
          PaymentTermsId: data.paymentTermsId,

        })
      }
    })
  }


  autosearchProduct(event: any) {
    this.salesService.autoSearchProduct(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.filterProductList = data;
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  setProduct(data: any) {
    this.createOrderForm.controls.productCode.setValue(data.value.productCode);
    this.createOrderForm.controls.productDescription.setValue(data.value.productName);
    this.createOrderForm.controls.productId.setValue(data.value.productId);
    this.addProductData = data.value;
    this.setFieldFocus('productQty');
  }

  setFieldFocus(fieldKey: any) {
    const control = this.el.nativeElement.querySelector('[formcontrolname="' + fieldKey + '"]');
    if (control) {
      setTimeout(() => {
        control.focus();
      }, 100);
    }
  }



  validateCustomer() {
    let isValid = true;

    if (
      !this.createOrderForm.controls.BillToCustomer?.valid ||
      !this.createOrderForm.controls.ShipToCustomer?.valid ||
      !this.createOrderForm.controls.warehouse?.valid ||
      !this.createOrderForm.controls.SalespersonCode?.valid ||
      !this.createOrderForm.controls.OrderNo?.valid ||
      !this.createOrderForm.controls.BillToCustomer?.valid ||
      !this.createOrderForm.controls.ShipToCustomer?.valid ||
      !this.createOrderForm.controls.WareHouseId?.valid

    ) {
      if (!this.createOrderForm.controls.BillToCustomer.value) {
        this.createOrderForm.controls.BillToCustomerCode.setValue('');
      } else if (!this.createOrderForm.controls.ShipToCustomer.value) {
        this.createOrderForm.controls.ShipToCustomerCode.setValue('');
      } else if (!this.createOrderForm.controls.WareHouseId.value) {
        this.createOrderForm.controls.warehouse.setValue('');
      }
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please fill Required field' });
      isValid = false;
    }

    return isValid;
  }

  // Function to check IGST based on warehouse and customer states
  async checkIGST() {
    const warehouseState = this.createOrderForm.controls.warehouseState.value;
    const CustomerState = this.createOrderForm.controls.BillToCustomerState.value;

    if (warehouseState == CustomerState) {
      this.isIGST = false;
    } else {
      this.isIGST = true;
    }
  }

  // Function to add a product to the quote
  async addProduct() {
    this.loader = true;
    this.submitted = true;

    await this.checkIGST();

    const isValid = this.validateCustomer();
    if (!isValid) {
      window.scroll(0, 0);
      this.loader = false;
      return;
    }

    const lastItem = this.allProductData[this.allProductData.length - 1];
    const productId = _.toNumber(this.createOrderForm.controls.productId.value);
    let costCalculationType: string;
    const deliveryDate = (this.createOrderForm.controls.requestedDate.value);

    try {
      const productData = await this.getProductById(productId);
      costCalculationType = productData.costCalculation || 'Qty';
    } catch (error) {
      console.error('Failed to fetch product data:', error);
      this.loader = false;
      return;
    }

    const product: Product = <Product>{
      SalesOrderNumber: _.toString(this.createOrderForm.controls.OrderNo.value),
      ProductId: productId,
      OrderQuantity: _.toNumber(this.createOrderForm.controls.productQty.value),
      Uom: _.toString(this.addProductData.unitsOfMeasure),
      LineItemNumber: (this.allProductData.length !== 0) ? lastItem.LineItemNumber + 1 : 1,
      IsTaxable: this.addProductData.isTaxable,
      StandardCost: this.addProductData.standardCost,
      UnitPrice: this.addProductData.salesPrice.toFixed(2),
      Weight: this.addProductData.weight,
      deliveryDate: deliveryDate,
      WareHouseId: _.toNumber(this.createOrderForm.controls.WareHouseId.value),
      ProductCode: this.addProductData.productCode,
      ProductDescription: this.addProductData.productName,
      CreatedBy: _.toString(this.createOrderForm.controls.CreatedBy.value),
      IsActive: true,
      DepartmentId: 0,
      LocationId: 0,
      SerialId: 0,
      VendnorId: 0,
      ProductSpecification: this.addProductData.productSpecification,

    }

    let extensionPrice: number;
    if (costCalculationType === 'Qty') {
      extensionPrice = product.UnitPrice * product.OrderQuantity;
    } else if (costCalculationType === 'Wgt') {
      extensionPrice = product.UnitPrice * product.OrderQuantity * product.Weight;
    } else {
      console.warn('Unknown costCalculation type:', costCalculationType);
      extensionPrice = 0;
    }
    product.ExtensionPrice = extensionPrice;

    product.CGST = (!this.isIGST) ? this.calculateGST(product.UnitPrice, product.OrderQuantity, this.addProductData.gst.gstRate, this.addProductData.isTaxable) / 2 : 0;
    product.SGST = (!this.isIGST) ? this.calculateGST(product.UnitPrice, product.OrderQuantity, this.addProductData.gst.gstRate, this.addProductData.isTaxable) / 2 : 0;
    product.IGST = (this.isIGST) ? this.calculateGST(product.UnitPrice, product.OrderQuantity, this.addProductData.gst.gstRate, this.addProductData.isTaxable) : 0;
    product.SalesTax = this.calculateGST(product.UnitPrice, product.OrderQuantity, this.addProductData.gst.gstRate, this.addProductData.isTaxable);

    if (this.isEdit) {
      this.products.push(product);
      this.createOrderForm.controls.productCode.setValue('');
      this.createOrderForm.controls.productDescription.setValue('');
      this.createOrderForm.controls.productQty.setValue('');
      this.loader = false;
      this.calculateOrderTotal();
      this.allProductData.push(product);
    } else {
      this.createSalesOrderLineItem(product);
    }
  }


  // Function to create a sales order line item in the database
  createSalesOrderLineItem(product: Product) {
    this.salesService.createSalesOrderLineItem(product).subscribe(
      async (data: any) => {
        if (data) {
          // console.log(data);
          product.SalesOrderLineItemId = data.lineItemId;
          this.products.push(product);
          this.createOrderForm.controls.productCode.setValue('');
          this.createOrderForm.controls.productDescription.setValue('')
          this.createOrderForm.controls.productQty.setValue('')
          this.loader = false;
          const isValid = this.calculateOrderTotal();
          // Create a sales order with a temporary status
          if (await isValid) {
            this.createSalesOrder('TEMP.ORDER');
          }
          this.allProductData.push(product);
        }
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while adding product' });
      }
    );
  }

  // Function to create a sales order
  createSalesOrder(value: string, MoveToShipping: boolean = false, sendEmail: boolean = false) {

    const SalesOrder: SalesOrder = <SalesOrder><unknown>{

      SalesOrderNumber: _.toString(this.createOrderForm.controls.OrderNo.value),
      OrderType: "ORDERTYPE.NORMAL",
      SalesOrderStatus: value,
      SalesOrderDate: new Date(),
      // ShipmentDate: this.createOrderForm.controls.ShipmentDate.value,
      SalespersonId: this.createOrderForm.controls.SalespersonId.value,
      SalespersonCode: this.createOrderForm.controls.SalespersonCode.value,
      CustomerId: this.createOrderForm.controls.BillToCustomerId.value,
      BillToCustomerCode: this.createOrderForm.controls.BillToCustomerCode.value,
      BillToCustomerId: this.createOrderForm.controls.BillToCustomerId.value,
      ShipToCustomerCode: this.createOrderForm.controls.ShipToCustomerCode.value,
      ShipToCustomerId: this.createOrderForm.controls.ShipToCustomerId.value,
      WarehouseId: this.createOrderForm.controls.WareHouseId.value,
      OrderTotal: this.orderTotal,
      totalWeight: this.weightTotal,
      CGSTTotal: this.CGSTtotal,
      SGSTTotal: this.SGSTtotal,
      IGSTTotal: this.IGSTtotal,
      SalesTaxTotal: this.SalesTaxTotal,
      IsActive: true,
      CreatedBy: this.createOrderForm.controls.CreatedBy.value,
      MotorVehicleNo: this.createOrderForm.controls.MotorVehicalNo.value,
      deliveryNote: this.createOrderForm.controls.deliveryNote.value,
      TermsCode: this.createOrderForm.controls.TermsCode.value,
      PaymentTermsId: this.createOrderForm.controls.PaymentTermsId.value,
      DispatchDocNo: this.createOrderForm.controls.DispatchDocNo.value,
      BillOfLading: this.createOrderForm.controls.BillOfLading.value,
      PurchaseOrderNumber: this.createOrderForm.controls.purchaseOrderNumber.value,
      LRRRNo: this.createOrderForm.controls.LRRRNo.value,
      DispatchThrough: this.createOrderForm.controls.DispatchThrough.value,
      BackOrderTotal: 0,
      MarginTotal: 0,
      ProfitTotal: 0,
      LabourTotal: 0,
      // FreightTotal: 0,
      ReferenceNumber: this.createOrderForm.controls.ReferenceNumber.value,
      Destination: this.createOrderForm.controls.Destination.value,
      TermsOfDelivery: this.createOrderForm.controls.TermsOfDelivery.value,
      CustomerPODate: this.createOrderForm.controls.CustomerPODate.value,
      //Status:"Open",
      driverName: this.createOrderForm.controls.driverName.value,
      driverContact: this.createOrderForm.controls.driverContact.value,
      RateOnFreight: this.createOrderForm.controls.RateOnFreight.value || 0,
      DiscountAmount: this.createOrderForm.controls.DiscountAmount.value || 0,
      FreightTotal: this.createOrderForm.controls.FreightTotal.value || 0,
      GSTOnFreight: this.createOrderForm.controls.GSTOnFreight.value || 0,
      FinalTaxableAmt: this.createOrderForm.controls.FinalTaxableAmt.value || 0,
      SupplyType: this.createOrderForm.controls.supplyType.value,
      IsLUT: this.createOrderForm.controls.isLUT.value,
      ExportType: this.createOrderForm.controls.expTyp.value,
      IsRCM: this.createOrderForm.controls.isRCM.value,
      POS: this.createOrderForm.controls.POS.value,
      projectBoMId: this.createOrderForm.controls.projectBoMId.value ?? undefined,
      projectName: this.createOrderForm.controls.projectName.value ?? undefined,
      projectNo: this.createOrderForm.controls.projectNo.value ?? undefined,
      FinancialYearId: Number(this.createOrderForm.controls['FinancialYearId'].value)
    };

    if (this.createOrderForm.controls.expDeliveryDate.value) {
      var expDeliveryDate = this.createOrderForm.controls.expDeliveryDate.value;
      const currentTime = new Date();
      expDeliveryDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      SalesOrder.expDeliveryDate = expDeliveryDate;
    }

    if (this.createOrderForm.controls.ShipmentDate.value) {
      // SalesOrder.ShipmentDate = this.createOrderForm.controls.ShipmentDate.value;
      var ShipmentDate = this.createOrderForm.controls.ShipmentDate.value;
      const currentTime = new Date();
      ShipmentDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      SalesOrder.ShipmentDate = ShipmentDate;
    }

    if (this.createOrderForm.controls.orderDate.value) {
      var orderDate = this.createOrderForm.controls.orderDate.value;
      const currentTime = new Date();
      orderDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      SalesOrder.orderDate = orderDate;
    }

    if (this.createOrderForm.controls.requestedDate.value) {
      var requestedDate = this.createOrderForm.controls.requestedDate.value;
      const currentTime = new Date();
      requestedDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      SalesOrder.requestedDate = requestedDate;
    }

    if (SalesOrder.requestedDate && SalesOrder.orderDate && SalesOrder.requestedDate < SalesOrder.orderDate) {
      this.loader = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Date Range',
        detail: 'The requested date cannot be earlier than the order date.'
      });
      return;
    }

    if (MoveToShipping) {
      SalesOrder.SalesOrderStatus = 'INVOICE';
      SalesOrder.SalesOrderInvoiceDate = new Date();
      SalesOrder.Status = "Open";
    }

    getISTDateWithCurrentTime(SalesOrder.CustomerPODate);
    // console.log(SalesOrder);
    this.loader = true;
    if (this.products.length === 1 && value === 'TEMP.ORDER' && !this.isEdit) {
      this.salesService.createSalesOrder(SalesOrder).subscribe(
        (data: any) => {
          if (data.success == true) {
            this.loader = false;
          }
          else {
            this.loader = false;
          }
        },
        (error: any) => {
          console.log(error);
          this.loader = false;
        }
      );
    }
    else {

      // if (this.isEdit) {
      //   SalesOrder.UpdatedBy = this.createOrderForm.controls.CreatedBy.value || '';
      //   SalesOrder.Status = this.createOrderForm.controls.Status.value || '';
      // }

      if (MoveToShipping) {
        SalesOrder.SalesOrderStatus = 'INVOICE';
        SalesOrder.SalesOrderInvoiceDate = new Date();
        SalesOrder.Status = "Open";
      }

      if (this.isEdit && value !== 'INVOICE') {
        SalesOrder.Status = this.createOrderForm.controls.Status.value || '';
        SalesOrder.TermsCode = this.createOrderForm.get('TermsCode')?.value || '';
        SalesOrder.PaymentTermsId = this.createOrderForm.get('PaymentTermsId')?.value ?? null;
      }

      this.salesService.updateSalesOrder(SalesOrder).subscribe(
        (data: any) => {
          if (data) {
            // console.log(data);
            this.loader = false;

            if (value === 'SHIPPING' || value === 'INVOICE') {
              if (value === 'INVOICE') {
                this.updateInventory();
                if (sendEmail) {
                  this.sendOrderEmail(data);
                }
                this.finishMoveToInvoice(
                  sendEmail ? 'Order Updated Successfully & Email Sent.' : 'Move To Invoice Successfully.'
                );
              } else {
                this.updateInventoryShipping('SHIPPING');
                if (sendEmail) {
                  this.sendOrderEmail(data);
                }
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: sendEmail ? 'Order Updated Successfully & Email Sent.' :
                    (this.isEdit ? 'Order Updated Successfully.' : 'Order Created Successfully.')
                });

                setTimeout(() => {
                  this.router.navigate(['/home/dispatchSalesOrder']);
                }, 1000);
              }
            }

          }
          else {
            console.log(data);
            this.loader = false;
          }
        },
        (error: any) => {
          console.log(error);
          this.loader = false;
          if (value === 'ORDER') {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed To Create Order.' });
          }
        }
      );
    }
  }

  isLineDiscountDisabled(): boolean {
    const discountAmount = Number(this.createOrderForm.get('DiscountAmount')?.value) || 0;
    return discountAmount > 0;
  }

  checkLineItemDiscounts() {
    const hasLineDiscount = this.products.some(p => Number(p.Discount) > 0);
    const discountControl = this.createOrderForm.get('DiscountAmount');
    if (hasLineDiscount) {
      discountControl?.setValue(0, { emitEvent: false });
      discountControl?.disable({ emitEvent: false });
    } else {
      discountControl?.enable({ emitEvent: false });
    }
    this.calculateOrderTotal();
  }



  async calculateOrderTotal() {

    await this.checkIGST();

    const isLUT =
      this.createOrderForm.get('isLUT')?.value === true &&
      (
        this.createOrderForm.get('supplyType')?.value === 'EXPORT' ||
        this.createOrderForm.get('supplyType')?.value === 'SEZ'
      );

    const isRCM = this.createOrderForm.get('isRCM')?.value === true;

    let totalWeight = 0;
    let taxableTotal = 0;

    let cgst = 0;
    let sgst = 0;
    let igst = 0;

    for (const product of this.products) {

      const productId = Number(product.ProductId);
      let costCalculationType = 'Qty';

      try {
        const productData = await this.getProductById(productId);
        costCalculationType = productData?.costCalculation || 'Qty';
      } catch (e) {
        console.error('Failed to fetch product data:', e);
      }

      const shipedQuantity = Number(product.ShipedQuantity) || 0;
      const shipedWeight = Number(product.ShipedWeight) || 0;
      const salesPrice = Number(product.UnitPrice) || 0;

      let baseAmount = 0;

      if (costCalculationType === 'Qty') {
        baseAmount = shipedQuantity * salesPrice;
        totalWeight += shipedQuantity;
      }
      else if (costCalculationType === 'Wgt') {
        baseAmount = shipedWeight * salesPrice;
        totalWeight += shipedWeight;
      }

      product.ExtensionPrice = _.round(baseAmount, 2);
      product.Amount = product.ExtensionPrice;

      taxableTotal += baseAmount;
    }

    const hasLineDiscount = this.products.some(
      p => Number(p.Discount) > 0
    );

    const discountControl = this.createOrderForm.get('DiscountAmount');

    if (hasLineDiscount) {
      if (discountControl?.enabled) {
        discountControl.setValue(0, { emitEvent: false });
        discountControl.disable({ emitEvent: false });
      }
    } else {
      if (discountControl?.disabled) {
        discountControl.enable({ emitEvent: false });
      }
    }

    const headerDiscount = hasLineDiscount
      ? 0
      : (Number(discountControl?.value) || 0);

    if (headerDiscount > taxableTotal && taxableTotal > 0) {

      if (
        discountControl?.dirty &&
        !discountControl?.hasError('exceedTotal')
      ) {

        this.messageService.clear();

        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Discount',
          detail: 'Discount cannot be greater than order total.'
        });
      }

      discountControl?.setErrors({ exceedTotal: true });

    } else {

      if (discountControl?.hasError('exceedTotal')) {
        discountControl.setErrors(null);
      }
    }

    const freightTotal =
      Number(this.createOrderForm.get('FreightTotal')?.value) || 0;

    const rateOnFreight =
      Number(this.createOrderForm.get('RateOnFreight')?.value) || 0;

    let gstOnFreight = 0;

    if (
      freightTotal > 0 &&
      rateOnFreight > 0 &&
      !isLUT &&
      !isRCM
    ) {

      gstOnFreight =
        (freightTotal * rateOnFreight) / 100;

      this.createOrderForm.get('GSTOnFreight')
        ?.setValue(_.round(gstOnFreight, 2), { emitEvent: false });

      if (this.isIGST) {

        igst += gstOnFreight;

      } else {

        cgst += gstOnFreight / 2;
        sgst += gstOnFreight / 2;
      }

    } else {

      this.createOrderForm.get('GSTOnFreight')
        ?.setValue(0, { emitEvent: false });
    }

    let finalTaxableAmtTotal = 0;

    for (const product of this.products) {

      const baseAmount = Number(product.ExtensionPrice) || 0;
      const gstRate = Number(product.GSTRate) || 0;
      const isTaxable = product.IsTaxable === true;

      let discountAmountForLine = 0;

      const explicitLineDiscountPercent =
        Number(product.Discount) || 0;

      if (explicitLineDiscountPercent > 0) {
        discountAmountForLine = discountAmountFromPercent(baseAmount, explicitLineDiscountPercent);
      }

      product.DiscountAmount =
        _.round(discountAmountForLine, 2);

      const netAmount =
        Math.max(0, baseAmount - discountAmountForLine);

      product.NetAmount =
        _.round(netAmount, 2);

      finalTaxableAmtTotal += netAmount;

      let lineGst = 0;
      let lineCgst = 0;
      let lineSgst = 0;
      let lineIgst = 0;

      if (isTaxable && gstRate > 0) {

        if (!isLUT && !isRCM) {

          lineGst =
            _.round((netAmount * gstRate) / 100, 2);

          if (this.isIGST) {

            lineIgst = lineGst;
            igst += lineGst;

          } else {

            lineCgst = _.round(lineGst / 2, 2);
            lineSgst = _.round(lineGst / 2, 2);

            cgst += lineCgst;
            sgst += lineSgst;
          }

        } else {

          lineGst = 0;
          lineCgst = 0;
          lineSgst = 0;
          lineIgst = 0;
        }
      }

      product.SalesTax = _.round(lineGst, 2);
      product.CGST = _.round(lineCgst, 2);
      product.SGST = _.round(lineSgst, 2);
      product.IGST = _.round(lineIgst, 2);

      product.LineTotal =
        _.round(netAmount + lineGst, 2);
    }

    this.weightTotal = _.round(totalWeight, 2);

    this.Taxable = _.round(finalTaxableAmtTotal, 2);
    this.NonTaxableTotal = 0;

    finalTaxableAmtTotal += freightTotal - headerDiscount;

    this.FinalTaxableAmt =
      _.round(finalTaxableAmtTotal, 2);

    this.createOrderForm.patchValue({
      FinalTaxableAmt: this.FinalTaxableAmt
    }, { emitEvent: false });

    this.CGSTtotal =
      this.isIGST ? 0 : _.round(cgst, 2);

    this.SGSTtotal =
      this.isIGST ? 0 : _.round(sgst, 2);

    this.IGSTtotal =
      this.isIGST ? _.round(igst, 2) : 0;

    this.orderTotal = _.round(
      finalTaxableAmtTotal +
      this.CGSTtotal +
      this.SGSTtotal +
      this.IGSTtotal,
      2
    );

    this.products = _.cloneDeep(this.products);

    // console.log('RCM=', isRCM);
    // console.log('LUT=', isLUT);
    // console.log('FinalTaxableAmt=', this.FinalTaxableAmt);
    // console.log('CGST=', this.CGSTtotal);
    // console.log('SGST=', this.SGSTtotal);
    // console.log('IGST=', this.IGSTtotal);

    return true;
  }

  calculateGST(price: number, quantity: number, gstrate: number, taxable: boolean): number {
    if (taxable === true) {
      const gst = (price * quantity) * gstrate / 100;
      return gst;
    }
    else {
      return 0;
    }
  }

  warning() {
    this.confirmationService.confirm({
      message: 'The entered quantity exceeds the order quantity. Please adjust the quantity.',
      header: 'Warning',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectVisible: false,
      acceptLabel: "OK",
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
      },

    });
  }

  getProductById(productId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.inventoryService.getProductById(productId).subscribe({
        next: (data: any) => resolve(data),
        error: (error) => reject(error),
      });
    });
  }

  async onProductEdit(event: any) {
    let editData = event;

    const getNum = (val: any) => _.toNumber(val) || 0;
    const parseCurrency = (val: any) =>
      parseFloat((val ?? 0).toString().replace(/[₹,]/g, '') || '0');

    if (!editData.ShipedQuantity) {
      editData.ShipedQuantity = 1;
    }

    if (editData.OrderQuantity < editData.ShipedQuantity) {
      editData.ShipedQuantity = editData.OrderQuantity;
    }

    const productId = editData.ProductId;
    let costCalculationType: string = 'Qty';

    try {
      const productData = await this.getProductById(productId);
      costCalculationType = productData.costCalculation || 'Qty';
    } catch (error) {
      console.error('Failed to fetch product data:', error);
      this.loader = false;
      return;
    }

    let extensionPrice: number;
    if (costCalculationType === 'Qty') {
      extensionPrice = editData.UnitPrice * editData.ShipedQuantity;
    } else if (costCalculationType === 'Wgt') {
      extensionPrice = editData.ShipedWeight * editData.UnitPrice;
    } else {
      extensionPrice = 0;
    }

    const lineDiscountPercent = getNum(editData.Discount) || 0;
    const lineAmount = extensionPrice;

    if (lineDiscountPercent > 100) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Discount',
        detail: `Discount percentage cannot be greater than 100%.`
      });
      return;
    }

    editData.ExtensionPrice = extensionPrice;
    editData.Discount = lineDiscountPercent;
    editData.DiscountAmount = discountAmountFromPercent(lineAmount, lineDiscountPercent);

    const gstRate = getNum(editData.GSTRate) || 0;

    let salesTax: number;
    if (costCalculationType === 'Wgt') {
      salesTax = _.round((editData.ShipedWeight * editData.UnitPrice * gstRate) / 100, 2);
    } else if (costCalculationType === 'Qty') {
      salesTax = _.round((editData.UnitPrice * editData.ShipedQuantity * gstRate) / 100, 2);
    } else {
      salesTax = 0;
    }

    editData.SalesTax = salesTax;
    editData.CGST = (!this.isIGST) ? _.round(salesTax / 2, 2) : 0;
    editData.SGST = (!this.isIGST) ? _.round(salesTax / 2, 2) : 0;
    editData.IGST = (this.isIGST) ? salesTax : 0;

    editData.UnitPrice = _.toNumber(editData.UnitPrice).toFixed(2);
    editData.NetAmount = _.round(editData.ExtensionPrice - editData.DiscountAmount, 2);
    editData.LineTotal = _.round(editData.NetAmount + editData.SalesTax, 2);

    const index = this.products.findIndex(product =>
      product.SalesOrderLineItemId === editData.SalesOrderLineItemId);

    if (index !== -1) {
      if (!this.isEdit) {
        this.updateSalesOrderLineItems(editData, index);
      } else {
        this.products[index] = {
          ...editData,
          ExtensionPrice: editData.ExtensionPrice,
          CGST: editData.CGST,
          SGST: editData.SGST,
          IGST: editData.IGST,
          SalesTax: editData.SalesTax,
          UnitPrice: editData.UnitPrice,
          Discount: editData.Discount,
          DiscountAmount: editData.DiscountAmount,
          NetAmount: editData.NetAmount,
          LineTotal: editData.LineTotal
        };
        this.checkLineItemDiscounts();
      }
    } else {
      console.error('Product not found', editData);
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while updating product' });
    }

    this.loader = false;
  }


  updateSalesOrderLineItems(data: Product, index: number) {
    this.loader = true;
    this.salesService.updateSalesOrderLineItem(data).subscribe(
      async (response: any) => {
        // console.log(response);
        // Update this.products only if the update is successfull
        if (index !== -1) {
          this.products[index] = {
            ...data,
            ExtensionPrice: data.ExtensionPrice,
            CGST: data.CGST,
            SGST: data.SGST,
            IGST: data.IGST,
            SalesTax: data.SalesTax,
            UnitPrice: data.UnitPrice,
            DiscountAmount: data.DiscountAmount,
            NetAmount: data.NetAmount,
            LineTotal: data.LineTotal
          };
          const isValid = this.calculateOrderTotal();
          if (await isValid) {
            this.createSalesOrder('TEMP.ORDER');
          }
        }
        this.loader = false;
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while updating product' });
        this.loader = false;
      }
    );
  }



  deleteProduct(reset: boolean = false) {

    this.confirmationService.confirm({
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      message: 'Do you want to delete?',
      accept: () => {

        var selectedProductIds: any
        if (!this.isEdit) {

          if (reset) {
            selectedProductIds = this.products.map(product => product.SalesOrderLineItemId);
          } else {
            selectedProductIds = this.selectedProduct.map(product => product.SalesOrderLineItemId);
          }

          this.loader = true;
          this.salesService.deleteSalesOrderLineItem(selectedProductIds).subscribe({
            next: async (data: any) => {
              if (data) {
                this.loader = false;
                this.products = this.products.filter(product => !selectedProductIds.includes(product.SalesOrderLineItemId));
                this.selectedProduct = [];
                // this.calculateOrderTotal();
                const isValid = this.calculateOrderTotal();
                if (await isValid) {
                  this.createSalesOrder('TEMP.ORDER');
                }
                if (reset) {
                  setTimeout(() => {
                    const OrderNo = this.createOrderForm.controls.OrderNo.value;
                    this.createOrderForm.reset();
                    this.createOrderForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
                    this.createOrderForm.controls.OrderNo.setValue(_.toString(OrderNo));
                  }, 2000);
                }
              }
            },
            error: error => {
              console.log(error);
              this.loader = false;
              this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Error while deleting product' });
            }
          });
        } else {
          this.deleteProductIds.push(
            ...this.selectedProduct
              .map(product => product.SalesOrderLineItemId)
              .filter(id => {
                return id && id.toString().trim() !== '';
              })
          );

          selectedProductIds = this.selectedProduct.map(product => product.LineItemNumber);
          this.products = this.products.filter(product => !selectedProductIds.includes(product.LineItemNumber));
          this.selectedProduct = [];
          this.calculateOrderTotal();
        }

      },
      reject: () => {
      }
    });

  }

  reOpen() {
    this.route.queryParams.subscribe(params => {
      try {
        const salesOrderId = JSON.parse(params['salesOrderId']);
        this.loader = true;
        this.salesService.getSalesOrderById(salesOrderId).subscribe({
          next: (data: any) => {
            if (data) {
              //console.log("Dispatch Details ", data);

              this.Data = data;
              this.salesOrderId = data.salesOrderId ?? salesOrderId ?? null;
              this.isEdit = true;

              const BillToCustomerAddress = data.billToCustomer?.address
                ? `${data.billToCustomer.address.state}, ${data.billToCustomer.address.country}, ${data.billToCustomer.address.zip}`
                : '';

              const ShipToCustomerAddress = data.shipToCustomer?.address
                ? `${data.shipToCustomer.address.state}, ${data.shipToCustomer.address.country}, ${data.shipToCustomer.address.zip}`
                : '';

              this.createOrderForm.patchValue({
                OrderNo: data.salesOrderNumber,
                BillToCustomerCode: data.billToCustomerCode,
                BillToCustomerId: data.billToCustomerId,
                BillToCustomer: data.billToCustomer?.customerName,
                ShipToCustomerCode: data.shipToCustomerCode,
                ShipToCustomerId: data.shipToCustomerId,
                ShipToCustomer: data.shipToCustomer?.customerName,
                saleserson: data.salesperson?.salespersonName,
                SalespersonCode: data.salespersonCode,
                SalespersonId: data.salespersonId,
                ShipmentDate: data.shipmentDate ? new Date(data.shipmentDate) : '',
                MotorVehicalNo: data.motorVehicleNo,
                warehouse: data.warehouse?.warehouseName,
                WareHouseId: data.warehouseId,
                TermsCode: data.termsCode,
                PaymentTermsId: data.paymentTermsId,
                DispatchDocNo: data.dispatchDocNo,
                BillOfLading: data.billOfLading,
                purchaseOrderNumber: data.purchaseOrderNumber,
                LRRRNo: data.lrrrNo,
                DispatchThrough: data.dispatchThrough,
                BillToCustomerAddress: BillToCustomerAddress,
                ShipToCustomerAddress: ShipToCustomerAddress,
                BillToCustomerState: data.billToCustomer?.address?.state,
                warehouseState: data.warehouse?.address?.state,
                orderDate: data.orderDate ? new Date(data.orderDate) : '',
                requestedDate: data.requestedDate ? new Date(data.requestedDate) : '',
                deliveryNote: data.deliveryNote,
                ReferenceNumber: data.referenceNumber,
                Destination: data.destination,
                TermsOfDelivery: data.termsOfDelivery,
                Status: data.status ?? 'Ready to Pick - 70%',
                CustomerPODate: data.customerPODate ? new Date(data.customerPODate) : null,
                driverName: data.driverName,
                driverContact: data.driverContact,
                expDeliveryDate: data.expDeliveryDate ? new Date(data.expDeliveryDate) : null,
                GSTOnFreight: data.gstOnFreight,
                FreightTotal: data.freightTotal,
                RateOnFreight: data.rateOnFreight,
                DiscountAmount: data.discountAmount,
                FinalTaxableAmt: data.finalTaxableAmt,

                //new
                BillToCustomerStateCode: data.billToCustomer?.address?.stateCode,
                ShipToCustomerStateCode: data.shipToCustomer?.address?.stateCode,
                warehouseStateCode: data.warehouse?.address?.stateCode,
                supplyType: data.supplyType,
                isLUT: data.isLUT ?? false,
                expTyp: data.exportType ?? '',
                isRCM: data.isRCM ?? false,
                POS: data.pos ?? '',
                projectBoMId: data.projectBoMId ?? null,
                projectName: data.projectName || data.projectBoM?.projectBoMName || '',
                projectNo: data.projectNo || data.projectBoM?.projectBoMCode || '',
                FinancialYearId: data.financialYearId,
              });

              // console.log(this.createOrderForm.controls['FinancialYearId'].value);

              const orderDate = this.createOrderForm.get('orderDate')?.value;
              if (orderDate) {
                this.onTransactionDateChange(orderDate, "Order");
              }

              const requestedDate = this.createOrderForm.get('requestedDate')?.value;
              if (requestedDate) {
                this.onTransactionDateChange(requestedDate, "Requested");
              }

              //this.subscribeFinancialYearChanges();


              if (this.isEdit) {
                this.createOrderForm.get('orderDate')?.disable();
              }

              setTimeout(() => {
                this.setPlaceOfSupply();
              });

              // console.log('isRCM=', data.isRCM);
              // console.log('isLUT=', data.isLUT);
              // console.log('SupplyType=', data.supplyType);
              // console.log('FinalTaxableAmt=', data.finalTaxableAmt);
              // console.log('OrderTotalAmt=', data.orderTotal);
              // console.log('CGST=', data.cgstTotal);
              // console.log('SGST=', data.sgstTotal);
              // console.log('IGST=', data.igstTotal);


              this.deliveryDate = data.requestedDate;
              this.weightTotal = data.weight;
              this.orderTotal = data.orderTotal;
              this.SalesTaxTotal = data.salesTaxTotal;
              this.CGSTtotal = data.cgstTotal;
              this.SGSTtotal = data.sgstTotal;
              this.IGSTtotal = data.igstTotal;
              this.customer = data.billToCustomer;
              this.customerEmail = data.billToCustomer?.email
                || data.customer?.email
                || data.customer?.emailID1
                || null;
              this.selectedCustomerEmail = this.customerEmail;
              this.selectedCustomerName = data.billToCustomer?.customerName
                || data.customer?.customerName
                || this.selectedCustomerName;
              this.deliveryDate = data.requestedDate;
              this.orderTotal = data.orderTotal;
              this.SalesTaxTotal = data.salesTaxTotal;
              this.CGSTtotal = data.cgstTotal;
              this.SGSTtotal = data.sgstTotal;
              this.IGSTtotal = data.igstTotal;
              this.Status = data.status;
              this.ShipmentDate = data.shipmentDate ? new Date(data.shipmentDate) : '',


                this.getSalesOrderLineItems(data.salesOrderNumber);
              // this.getShipto(data.shipToCustomerId);
            }
          },
          error: error => {
            this.router.navigate(['/home/dashboard']);
            console.error(error);
            this.loader = false;
          }
        })
      }
      catch (error) {
        this.router.navigate(['/home/dashboard']);
        console.error('Error details:', error);
      }
    })
  }

  getShipto(data: number) {
    this.loader = true;
    this.customerService.getCustomerById(data).subscribe({
      next: (data: any) => {
        const ShipTo = data;
        this.createOrderForm.controls.ShipToCustomer.setValue(ShipTo.customerName);
        const address = `${ShipTo.address.city, ShipTo.address.state}, ${ShipTo.address.country}, ${ShipTo.address.zip}`;
        this.createOrderForm.controls.ShipToCustomerAddress.setValue(address);
        this.loader = false;

      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    })
  }

  getSalesOrderLineItems(salesOrderNumber: number) {
    this.loader = true;
    this.salesService.getSalesOrderLineItem(salesOrderNumber).subscribe(
      (data: any) => {
        this.products = this.loadProducts(data);
        // console.log(this.products);
        this.allProductData = this.products;
        this.calculateOrderTotal();
        this.loader = false;
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
      }
    );
  }

  loadProducts(data: any): Product[] {
    return data.map((item: any) => {
      return this.loadProduct(item);
    });
  }

  loadProduct(data: any) {
    const product: Product = <Product>{
      SalesOrderLineItemId: data.salesOrderLineItemId,
      SalesOrderNumber: data.salesOrderNumber,
      ProductId: data.productId,
      OrderQuantity: data.orderQuantity,
      // QuotedQuantity: data.quotedQuantity,
      ProductSpecification: data.productSpecification,
      ShipedQuantity: data.shipedQuantity,
      ShipedWeight: (data.shipedWeight) ? data.shipedWeight : 0,
      Uom: data.uom,
      LineItemNumber: data.lineItemNumber,
      IsTaxable: data.isTaxable,
      StandardCost: data.standardCost,
      UnitPrice: data.unitPrice,
      ExtensionPrice: data.extensionPrice,
      Comment: data.comment,
      deliveryDate: data.deliveryDate ? new Date(data.deliveryDate) : null,
      GSTRate: data.gstRate,
      HSNCode: data.hsnCode,
      CGST: data.cgst,
      SGST: data.sgst,
      IGST: data.igst,
      SalesTax: data.salesTax,
      Weight: data.weight,
      WareHouseId: data.wareHouseId,
      ProductCode: data.productCode,
      ProductDescription: data.productDescription,
      CreatedBy: data.createdBy,
      IsActive: true,
      DepartmentId: 0,
      LocationId: 0,
      SerialId: 0,
      VendnorId: 0,
      Discount: data.discount || 0,
      DiscountAmount: data.discountAmount || 0,
      NetAmount: data.netAmount || 0,
      LineTotal: data.lineTotal || 0,
    }
    return product;
  }


  // update(){}

  async update(MoveToShipping: boolean = false, sendEmail: boolean = false) {
    const promises: Promise<any>[] = [];

    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    if (!this.validateFinancialYear()) {
      return;
    }

    if (this.products.length < 1) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
      const productCodeAutoCompleteElement = this.el.nativeElement.querySelector('[formControlName="productCode"]');
      if (productCodeAutoCompleteElement) {
        productCodeAutoCompleteElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    this.loader = true;
    this.salesService.deleteSalesOrderLineItem(this.deleteProductIds).subscribe({
      next: (data: any) => {
        if (data) {
          this.loader = false;
        }
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });

    for (const product of this.products) {

      product.BackOrderQuantity = product.OrderQuantity - product.ShipedQuantity;
      if (product.deliveryDate) {
        const correctedDate = new Date(product.deliveryDate);
        const currentTime = new Date();
        correctedDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
        product.deliveryDate = correctedDate;
      }
      this.loader = true;
      const updatePromise = this.salesService.updateSalesOrderLineItem(product).toPromise();
      promises.push(updatePromise);
      updatePromise.then(
        (data: any) => {
          this.loader = false;
        },
        (error: any) => {
          console.log(error);
          this.loader = false;
        }
      );

    }

    await Promise.all(promises);

    this.createSalesOrder('SHIPPING', false, sendEmail);
  }

  async movetoInvoice() {

    if (!this.validateFinancialYear()) {
      return;
    }

    let allZero = true;

    for (const product of this.products) {
      const productData = await this.getProductById(product.ProductId);
      const costCalculationType = productData.costCalculation || 'Qty';

      if (costCalculationType === 'Qty' && product.ShipedQuantity === 0) {
        allZero = true;
      }

      if (product.ShipedQuantity !== 0 || product.ShipedWeight !== 0) {
        allZero = false;
      }

      if (product.ShipedQuantity !== product.OrderQuantity || product.Weight !== product.ShipedWeight) {
        this.isBO = true;
      }
    }

    if (allZero) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please Enter Shipped Quantity.' });
      return;
    }

    this.invoiceAmount = this.orderTotal;
    this.totalOutstanding = this.customer?.outstandingRec || 0;
    this.customerCreditLimit = this.customer?.creditLimit || 0;

    const noCreditCheckRaw = this.customer?.noCreditCheck;

    const creditCheck = noCreditCheckRaw === true || noCreditCheckRaw === 'true';

    if (!creditCheck) {
      const totalReceivables = this.totalOutstanding + this.invoiceAmount;
      if (totalReceivables > this.customerCreditLimit) {
        this.exceededAmount = totalReceivables - this.customerCreditLimit;
        this.creditLimitExceeded = true;
        return;
      }
    }

    this.continueInvoiceCreation();
  }

  toggleDetails(event: Event) {
    event.preventDefault();
    this.showCreditDetails = !this.showCreditDetails;
  }

  continueInvoiceCreation() {
    for (let product of this.products) {
      product.BackOrderQuantity = product.OrderQuantity - product.ShipedQuantity;

      if (product.deliveryDate) {
        const correctedDate = new Date(product.deliveryDate);
        const currentTime = new Date();
        correctedDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
        product.deliveryDate = correctedDate;
      }

      this.loader = true;

      this.salesService.updateSalesOrderLineItem(product).subscribe(
        (data: any) => {
          if (!data) this.loader = false;
        },
        (error: any) => {
          console.log(error);
          this.loader = false;
        }
      );
    }

    this.customer.outstandingRec = this.totalOutstanding + this.orderTotal;
    this.sendInvoiceEmail();
    this.customerService.updateOutstandingReceivables(this.customer).subscribe({
      next: (data: any) => {
        console.log('Customer updated successfully.');
        this.loader = false;
      },
      error: (err: any) => {
        console.error('Failed to update customer:', err);
        this.loader = false;
      }
    });

    if (this.isBO) {
      this.splitBOLineItem();
    } else {
      //this.createSalesOrder('INVOICE', true);
      this.createSalesOrderAR('INVOICE', true);
    }

    this.creditLimitExceeded = false;
    this.showCreditDetails = false;

  }

  closeCreditDialog() {
    this.creditLimitExceeded = false;
    this.showCreditDetails = false;
  }


  updateInventory(status: string = "DirectInvoice") {
    this.loader = true;

    const data = this.createOrderForm.value;

    for (let product of this.products) {

      const Inventory: UpdateInventory = <UpdateInventory>{
        productId: product.ProductId,
        warehouseId: _.toNumber(data.WareHouseId),
        productCode: product.ProductCode,
        status: status,
        transactionNo: _.toString(data.OrderNo),
        transactionType: "Invoice",
        quantity: product.ShipedQuantity || 0,
        uom: product.Uom,
        createdBy: localStorage.getItem('username'),
        transactionDate: new Date(),
        createdDate: new Date(),
      }

      // console.log(Inventory);
      this.inventoryService.updateInventory(Inventory).subscribe({
        next: (data: any) => {
          // console.log(data);
          this.loader = false;
        },
        error: error => {
          console.log(error);
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while Inventory Update.' });
          this.loader = false;
          return;
        }
      });

    }
  }
  updateInventoryShipping(status: string = "SHIPPING") {
    this.loader = true;

    const data = this.createOrderForm.value;

    for (let product of this.allProductData) {

      const Inventory: UpdateInventory = <UpdateInventory>{
        productId: product.ProductId,
        warehouseId: _.toNumber(data.WareHouseId),
        productCode: product.ProductCode,
        status: status,
        transactionNo: _.toString(data.OrderNo),
        transactionType: "Order",
        quantity: product.ShipedQuantity,
        createdBy: localStorage.getItem('username'),
        transactionDate: new Date(),
        createdDate: new Date(),
      }

      this.inventoryService.updateInventory(Inventory).subscribe({
        next: (data: any) => {
          this.loader = false;
        },
        error: error => {
          console.log(error);
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while Inventory Update.' });
          this.loader = false;
          return;
        }
      });

    }
  }


  viewProduct(data?: any) {
    const productData = data || this.selectedProduct[0];
    const normalizedData = this.normalizeProductIdInPlace(productData);
    const productDataJson = JSON.stringify(normalizedData);
    this.productId = normalizedData.productId;

    const ref = this.dialogService.open(viewproductLookupComponent, {
      header: 'Product Details',
      width: '70%',
      data: {
        productData: productDataJson,
        productId: this.productId
      }
    });

    let messageShown = false;

    ref.onClose.subscribe(updatedProduct => {
      if (updatedProduct && !messageShown) {
        this.updateProductInGrid(productData, updatedProduct);

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Product updated successfully.`
        });
        messageShown = true;
      }
    });
  }

  updateProductInGrid(originalProduct: any, updatedProduct: any) {
    originalProduct.ProductCode = updatedProduct.ProductCode;
    originalProduct.ProductDescription = updatedProduct.ProductName;
    originalProduct.Uom = updatedProduct.unitsofMeasure || updatedProduct.UnitsOfMeasure;
    originalProduct.GSTRate = updatedProduct.gstRate;
    originalProduct.HSNCode = updatedProduct.HSNCode;
    originalProduct.UnitPrice = updatedProduct.SalesPrice;
    originalProduct.ExtensionPrice = updatedProduct.
      SalesPrice * originalProduct.ShipedQuantity;
    originalProduct.ProductSpecification = updatedProduct.ProductSpecification;

    const quantity = +originalProduct.ShipedQuantity || 0;
    const cost = +originalProduct.Cost || 0;
    const gstRate = +updatedProduct.gstRate || 0;

    const baseCost = quantity * cost;

    const discountRate = +originalProduct.Discount || 0;
    const discountAmount = +(baseCost * (discountRate / 100)).toFixed(2);
    const taxableAmount = +(baseCost - discountAmount).toFixed(2);

    let cgst = 0, sgst = 0, igst = 0;

    if (this.isIGST) {
      igst = +(taxableAmount * gstRate / 100).toFixed(2);
    } else {
      const halfRate = gstRate / 2;
      cgst = +(taxableAmount * halfRate / 100).toFixed(2);
      sgst = +(taxableAmount * halfRate / 100).toFixed(2);
    }

    const totalTax = +(cgst + sgst + igst).toFixed(2);

    const totalWithTax = +(taxableAmount + totalTax).toFixed(2);

    originalProduct.CGST = cgst;
    originalProduct.SGST = sgst;
    originalProduct.IGST = igst;
    originalProduct.SalesTax = totalTax;
    originalProduct.TaxableAmount = taxableAmount;
    originalProduct.TotalWithTax = totalWithTax;
    originalProduct.ExtendedCost = taxableAmount;

    this.products = [...this.products];

    this.calculateOrderTotal();
  }


  private normalizeProductIdInPlace(product: any): any {
    if (product && product.ProductId) {
      return {
        ...product,
        productId: product.ProductId,
      };
    }
    return product;
  }

  splitBOLineItem() {
    const BOProducts: Product[] = [];

    for (let product of this.products) {
      let orderQty = product.OrderQuantity;
      let ShippedQty = product.ShipedQuantity;
      let BOQty = product.OrderQuantity - product.ShipedQuantity;
      let orderWeight = product.Weight;
      let ShippedWeight = product.ShipedWeight;
      let BOWeight = product.Weight - product.ShipedWeight;

      if (orderQty !== ShippedQty || orderWeight !== ShippedWeight) {
        delete (product as any).SalesOrderLineItemId;
        BOProducts.push({
          ...product,
          QuotedQuantity: 0,
          OrderQuantity: 0,
          ShipedQuantity: 0,
          SalesOrderNumber: this.generateBOno(this.createOrderForm.controls.OrderNo.value || ''),
          Weight: BOWeight,
          ShipedWeight: BOWeight,
          BackOrderQuantity: BOQty,
          ExtensionPrice: product.UnitPrice * BOQty,
          CGST: (!this.isIGST) ? this.calculateGST(product.UnitPrice, BOQty, product.GSTRate, product.IsTaxable) / 2 : 0,
          SGST: (!this.isIGST) ? this.calculateGST(product.UnitPrice, BOQty, product.GSTRate, product.IsTaxable) / 2 : 0,
          IGST: (this.isIGST) ? this.calculateGST(product.UnitPrice, BOQty, product.GSTRate, product.IsTaxable) : 0,
          LineItemNumber: BOProducts.length + 1
        });
      }

    }

    this.BOproducts = BOProducts;

    this.calculateBOTotal();

  }

  async calculateBOTotal() {
    let orderTotal = 0;
    let cgst = 0;
    let sgst = 0;
    let igst = 0;
    let weight = 0;
    let taxable = 0;

    // Create an array of promises to fetch product data
    const productPromises = this.BOproducts.map(async (product) => {
      const productId = _.toNumber(product.ProductId);
      let costCalculationType;

      try {
        const productData = await this.getProductById(productId);
        costCalculationType = productData.costCalculation || 'Qty';

        const backOrderQuantity = _.toNumber(product.BackOrderQuantity);
        const salesPrice = parseFloat(product.UnitPrice.toString().replace('₹', '').replace(',', '')) || 0;
        const productWeight = product.Weight || 0;

        let extensionPrice = 0;

        // Calculate extension price based on cost calculation type
        if (costCalculationType === 'Qty') {
          extensionPrice = backOrderQuantity * salesPrice;
        } else if (costCalculationType === 'Wgt') {
          extensionPrice = productWeight * salesPrice;
        } else {
          console.warn('Unknown costCalculation type:', costCalculationType);
          return; // Skip unknown types
        }

        // Accumulate totals
        orderTotal += extensionPrice;
        if (product.IsTaxable) {
          taxable += extensionPrice;
          cgst += product.CGST || 0;
          sgst += product.SGST || 0;
          igst += product.IGST || 0;
        }
        weight += productWeight * backOrderQuantity;

      } catch (error) {
        console.error('Failed to fetch product data:', error);
      }
    });

    // Wait for all product data to be fetched
    await Promise.all(productPromises);

    // Calculate totals for BO details
    this.BODetails = {
      OrderTotal: parseFloat((orderTotal + cgst + sgst + igst).toFixed(2)),
      CGSTtotal: parseFloat(cgst.toFixed(2)),
      SGSTtotal: parseFloat(sgst.toFixed(2)),
      IGSTtotal: parseFloat(igst.toFixed(2)),
      WeightTotal: parseFloat(weight.toFixed(2)),
      SalesTaxTotal: parseFloat((cgst + sgst + igst).toFixed(2)),
    };

    // Create BO with updated details
    this.createBO();
  }


  createBO() {
    const SalesOrder: SalesOrder = <SalesOrder><unknown>{
      SalesOrderNumber: this.generateBOno(this.createOrderForm.controls.OrderNo.value || ''),
      OrderType: "ORDERTYPE.NORMAL",
      SalesOrderStatus: 'BACKORDER',
      SalesOrderDate: new Date(),
      BackOrderStatus: 'Open',
      SalespersonId: this.createOrderForm.controls.SalespersonId.value,
      SalespersonCode: this.createOrderForm.controls.SalespersonCode.value,
      CustomerId: this.createOrderForm.controls.BillToCustomerId.value,
      BillToCustomerCode: this.createOrderForm.controls.BillToCustomerCode.value,
      BillToCustomerId: this.createOrderForm.controls.BillToCustomerId.value,
      ShipToCustomerCode: this.createOrderForm.controls.ShipToCustomerCode.value,
      ShipToCustomerId: this.createOrderForm.controls.ShipToCustomerId.value,
      WarehouseId: this.createOrderForm.controls.WareHouseId.value,
      OrderTotal: this.BODetails.OrderTotal,
      totalWeight: this.BODetails.WeightTotal,
      CGSTTotal: this.BODetails.CGSTtotal,
      SGSTTotal: this.BODetails.SGSTtotal,
      IGSTTotal: this.BODetails.IGSTtotal,
      SalesTaxTotal: this.BODetails.SalesTaxTotal,
      IsActive: true,
      CreatedBy: this.createOrderForm.controls.CreatedBy.value,
      MotorVehicleNo: this.createOrderForm.controls.MotorVehicalNo.value,
      deliveryNote: this.createOrderForm.controls.deliveryNote.value,
      TermsCode: this.createOrderForm.controls.TermsCode.value,
      PaymentTermsId: this.createOrderForm.controls.PaymentTermsId.value,
      DispatchDocNo: this.createOrderForm.controls.DispatchDocNo.value,
      BillOfLading: this.createOrderForm.controls.BillOfLading.value,
      PurchaseOrderNumber: this.createOrderForm.controls.purchaseOrderNumber.value,
      LRRRNo: this.createOrderForm.controls.LRRRNo.value,
      DispatchThrough: this.createOrderForm.controls.DispatchThrough.value,
      BackOrderTotal: this.BODetails.OrderTotal,
      MarginTotal: 0,
      ProfitTotal: 0,
      LabourTotal: 0,
      FreightTotal: 0,
    };

    if (this.createOrderForm.controls.orderDate.value) {
      var orderDate = this.createOrderForm.controls.orderDate.value;
      const currentTime = new Date();
      orderDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      SalesOrder.orderDate = orderDate;
    }

    if (this.createOrderForm.controls.requestedDate.value) {
      var requestedDate = this.createOrderForm.controls.requestedDate.value;
      const currentTime = new Date();
      requestedDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      SalesOrder.requestedDate = requestedDate;
    }

    this.salesService.createSalesOrder(SalesOrder).subscribe(
      (data: any) => {
        if (data.success == true) {
          this.createBOLineItem();
        }
        else {
          this.loader = false;
        }
      },
      (error: any) => {
        console.log(error);
        this.loader = false;
      }
    );

  }

  generateBOno(input: string) {
    const regex = /^(.+?)(-(\d+))?$/;

    const inputStr = String(input);

    const match = inputStr.match(regex);

    if (match) {
      const baseNumber = match[1];
      const suffixNumber = match[3] ? parseInt(match[3], 10) : 0;

      const newSuffixNumber = suffixNumber + 1;

      return newSuffixNumber === 1 && suffixNumber === 0
        ? `${baseNumber}-1`
        : `${baseNumber}-${newSuffixNumber}`;
    }

    return inputStr;
  }

  async createBOLineItem() {

    const promises: Promise<any>[] = [];

    for (let product of this.BOproducts) {
      const updatePromise = this.salesService.createSalesOrderLineItem(product).toPromise();
      promises.push(updatePromise);
      updatePromise.then(
        (data: any) => {
          // console.log(data);
        },
        (error: any) => {
          console.error(error);
          this.loader = false;
        }
      );
    }

    await Promise.all(promises);

    this.createSalesOrder('INVOICE', true);

  }
  //   async toggleEdit(product: Product, field: 'Weight' | 'ShipedQuantity') {
  //     try {
  //         const productData = await this.getProductById(product.ProductId);
  //         const costCalculationType = productData.costCalculation || 'Qty';
  //         this.isEditingQuantity = false;
  //         this.isEditingWeight = false;
  //     } catch (error) {
  //         console.error('Error fetching product data:', error);
  //     }
  // }


  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();
    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }
  onKeydown(event: KeyboardEvent, product: any) {
    if (event.key === 'Enter' || event.key === 'Tab') {
      event.preventDefault();
      this.onProductEdit(product);
      if (event.key === 'Tab') {
        this.moveFocusToNextField(event, product);
      }
    }
  }

  moveFocusToNextField(event: KeyboardEvent, product: any) {
    const inputs = document.querySelectorAll('input');
    const currentIndex = Array.from(inputs).indexOf(event.target as HTMLInputElement);
    const nextInput = inputs[currentIndex + 1] as HTMLInputElement;

    if (nextInput) {
      nextInput.focus();
    }
  }

  openLinkedFiles() {
    if (this.ref) {
      this.ref.close();
    }
    const orderNo = this.createOrderForm.controls.OrderNo.value;
    this.ref = this.dialogService.open(ListLinkedFilesLookupComponent, {
      header: `Linked File For Order ${orderNo}`,
      width: '60%',
      data: { orderNo: orderNo }
    });
  }


  showComment(productItem: Product) {
    this.ref = this.dialogService.open(POCommentsLookupComponent, {
      header: 'Order Line Remark',
      width: '50%',
      data: productItem
    });
    this.ref.onClose.subscribe((data: string) => {
      if (data) {
        productItem.Comment = data;
        this.onProductEdit(productItem);
      }
    });
  }

  showSpecification(productItem: any) {
    this.ref = this.dialogService.open(SpecificationLookupComponent, {
      header: 'Order Line Specification',
      width: '50%',
      data: productItem
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        productItem.ProductSpecification = data.ProductSpecification;
        this.onProductEdit(productItem);
      }
    });
  }

  createSalesOrderAR(value: string, MoveToShipping: boolean = false) {

    const SalesOrder: SalesOrder = <SalesOrder><unknown>{
      SalesOrderNumber: _.toString(this.createOrderForm.controls.OrderNo.value),
      OrderType: "ORDERTYPE.NORMAL",
      SalesOrderStatus: value,
      SalesOrderDate: new Date(),
      // ShipmentDate: this.createOrderForm.controls.ShipmentDate.value,
      SalespersonId: this.createOrderForm.controls.SalespersonId.value,
      SalespersonCode: this.createOrderForm.controls.SalespersonCode.value,
      CustomerId: this.createOrderForm.controls.BillToCustomerId.value,
      BillToCustomerCode: this.createOrderForm.controls.BillToCustomerCode.value,
      BillToCustomerId: this.createOrderForm.controls.BillToCustomerId.value,
      ShipToCustomerCode: this.createOrderForm.controls.ShipToCustomerCode.value,
      ShipToCustomerId: this.createOrderForm.controls.ShipToCustomerId.value,
      WarehouseId: this.createOrderForm.controls.WareHouseId.value,
      OrderTotal: this.orderTotal,
      totalWeight: this.weightTotal,
      CGSTTotal: this.CGSTtotal,
      SGSTTotal: this.SGSTtotal,
      IGSTTotal: this.IGSTtotal,
      SalesTaxTotal: this.SalesTaxTotal,
      IsActive: true,
      CreatedBy: this.createOrderForm.controls.CreatedBy.value,
      MotorVehicleNo: this.createOrderForm.controls.MotorVehicalNo.value,
      deliveryNote: this.createOrderForm.controls.deliveryNote.value,
      TermsCode: this.createOrderForm.controls.TermsCode.value,
      PaymentTermsId: this.createOrderForm.controls.PaymentTermsId.value,
      DispatchDocNo: this.createOrderForm.controls.DispatchDocNo.value,
      BillOfLading: this.createOrderForm.controls.BillOfLading.value,
      PurchaseOrderNumber: this.createOrderForm.controls.purchaseOrderNumber.value,
      LRRRNo: this.createOrderForm.controls.LRRRNo.value,
      DispatchThrough: this.createOrderForm.controls.DispatchThrough.value,
      BackOrderTotal: 0,
      MarginTotal: 0,
      ProfitTotal: 0,
      LabourTotal: 0,
      // FreightTotal: 0,
      ReferenceNumber: this.createOrderForm.controls.ReferenceNumber.value,
      Destination: this.createOrderForm.controls.Destination.value,
      TermsOfDelivery: this.createOrderForm.controls.TermsOfDelivery.value,
      RateOnFreight: this.createOrderForm.controls.RateOnFreight.value || 0,
      DiscountAmount: this.createOrderForm.controls.DiscountAmount.value || 0,
      FreightTotal: this.createOrderForm.controls.FreightTotal.value || 0,
      GSTOnFreight: this.createOrderForm.controls.GSTOnFreight.value || 0,
      FinalTaxableAmt: this.createOrderForm.controls.FinalTaxableAmt.value || 0,
    };

    if (this.createOrderForm.controls.ShipmentDate.value) {
      // SalesOrder.ShipmentDate = this.createOrderForm.controls.ShipmentDate.value;
      var ShipmentDate = this.createOrderForm.controls.ShipmentDate.value;
      const currentTime = new Date();
      ShipmentDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      SalesOrder.ShipmentDate = ShipmentDate;
    }

    if (this.createOrderForm.controls.orderDate.value) {
      var orderDate = this.createOrderForm.controls.orderDate.value;
      const currentTime = new Date();
      orderDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      SalesOrder.orderDate = orderDate;
    }

    if (this.createOrderForm.controls.requestedDate.value) {
      var requestedDate = this.createOrderForm.controls.requestedDate.value;
      const currentTime = new Date();
      requestedDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
      SalesOrder.requestedDate = requestedDate;
    }

    if (SalesOrder.requestedDate && SalesOrder.orderDate && SalesOrder.requestedDate < SalesOrder.orderDate) {
      this.loader = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Date Range',
        detail: 'The requested date cannot be earlier than the order date.'
      });
      return;
    }

    if (MoveToShipping) {
      SalesOrder.SalesOrderStatus = 'INVOICE';
      SalesOrder.SalesOrderInvoiceDate = new Date();
      SalesOrder.Status = "Open";
    }

    // console.log(SalesOrder);
    this.loader = true;
    if (this.products.length === 1 && value === 'TEMP.ORDER' && !this.isEdit) {
      this.salesService.createSalesOrder(SalesOrder).subscribe(
        (data: any) => {
          if (data.success == true) {
            this.loader = false;
          }
          else {
            this.loader = false;
          }
        },
        (error: any) => {
          console.log(error);
          this.loader = false;
        }
      );
    }
    else {

      if (this.isEdit) {
        SalesOrder.UpdatedBy = this.createOrderForm.controls.CreatedBy.value || '';
        // SalesOrder.Status = this.createOrderForm.controls.Status.value || '';
        SalesOrder.Status = "Open";
      }

      //this.salesService.updateSalesOrder(SalesOrder).subscribe(
      this.salesService.createSalesOrderWithAR(SalesOrder).subscribe(
        (data: any) => {
          if (data) {
            // console.log(data);
            this.loader = false;

            if (value === 'SHIPPING' || value === 'INVOICE') {
              if (value === 'INVOICE') {
                this.updateInventory();
                this.finishMoveToInvoice('Move To Invoice Successfully.');
              } else {
                if (this.isEdit) {
                  this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Order Updated Successfully.' });
                } else {
                  this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Order Created Successfully.' });
                }
                setTimeout(() => {
                  this.router.navigate(['/home/dispatchSalesOrder']);
                }, 1000);
              }
            }

          }
          else {
            console.log(data);
            this.loader = false;
          }
        },
        (error: any) => {
          console.log(error);
          this.loader = false;
          if (value === 'ORDER') {
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed To Create Order.' });
          }
        }
      );
    }
  }

  onSavePopupHide() {
    this.savePopupVisible = false;
  }

  showSaveOptionsPopup() {
    if (this.autoSendEmail) {
      this.savePopupVisible = true;
    } else {
      this.update(false, false);
    }
  }

  updateOnly() {
    this.savePopupVisible = false;
    this.update(false, false);
  }

  updateAndSend() {
    this.savePopupVisible = false;
    this.update(false, true);
  }


  openSavePopup() {
    this.confirmationService.confirm({
      message: 'Choose an action:',
      header: 'Save Options',
      icon: 'pi pi-info-circle',
      acceptLabel: 'Update',
      rejectLabel: 'Update & Send',
      acceptButtonStyleClass: 'p-button-info',
      rejectButtonStyleClass: 'p-button-success',

      accept: () => {
        this.validateSalesOrder('SHIPPING', false);
      },

      reject: () => {
        this.validateSalesOrder('SHIPPING', true);
      }
    });
  }

  sendOrderEmail(order: any) {

    const authString = localStorage.getItem('auth');
    if (!authString) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Auth information is missing' });
      return;
    }

    const auth = JSON.parse(authString);
    if (!auth.tenant?.tenantCode) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Tenant Code is missing' });
      return;
    }

    const tenant = auth.tenant.tenantCode;
    const formCode = 'Order';
    this.loader = true;

    this.getUserDepartmentName().subscribe(departmentName => {

      this.reportService.getReportName(formCode).subscribe({
        next: (report: any) => {
          this.ReportPath = report.path;
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Report not found' });
        }
      });

      const templateCode =
        (this.createOrderForm.controls.Status.value || this.Status) === 'Dispatched - 100%'
          ? 'sales-order-Dispatched-update-template'
          : 'sales-order-status-update-template';
      this.salesService.getEmailTemplate(tenant, templateCode).pipe(
        map((templateResponse: any) => {
          const template =
            templateResponse?.body ??
            templateResponse?.Body ??
            templateResponse?.templateBody ??
            templateResponse?.TemplateBody ??
            templateResponse?.emailBody ??
            templateResponse?.EmailBody;

          if (!template) {
            throw new Error('Email template body not found in response');
          }

          const formatCurrency = (value: any) => {
            const numericValue = typeof value === 'number' ? value : parseFloat(value);
            const safeValue = Number.isFinite(numericValue) ? numericValue : 0;
            return `₹${safeValue.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;
          };

          const rawOrderDate =
            this.createOrderForm.controls.orderDate.value ||
            order?.SalesOrderDate ||
            order?.orderDate ||
            null;

          const safeDate = formatDateDDMMYY(rawOrderDate);
          const templateData = {
            customerName: this.createOrderForm.controls.BillToCustomer.value
              || this.createOrderForm.controls.BillToCustomerCode.value
              || order?.CustomerName
              || '',
            orderNumber: this.createOrderForm.controls.OrderNo.value
              || order?.SalesOrderNumber
              || '',
            orderDate: safeDate,
            shipToName: this.createOrderForm.controls.ShipToCustomer.value
              || this.createOrderForm.controls.ShipToCustomerCode.value
              || order?.ShipToCustomerCode
              || '',
            salespersonName: this.createOrderForm.controls.saleserson.value
              || this.createOrderForm.controls.SalespersonCode.value
              || '',
            salespersonCode: this.createOrderForm.controls.SalespersonCode.value || '',
            warehouseName: this.createOrderForm.controls.warehouse.value
              || this.createOrderForm.controls.WareHouseId.value
              || '',
            orderTotal: formatCurrency(this.orderTotal),
            cgstTotal: formatCurrency(this.CGSTtotal),
            sgstTotal: formatCurrency(this.SGSTtotal),
            igstTotal: formatCurrency(this.IGSTtotal),
            salesTaxTotal: formatCurrency(this.SalesTaxTotal),
            currentYear: new Date().getFullYear(),
            companyName: this.companyInfo?.companyName || '',
            companyEmail: this.companyInfo?.companyEmail || '',
            companyPhone: this.companyInfo?.companyPhone || '',
            companyWebsite: this.companyInfo?.companyWebsite || '',
            orderStatus: this.createOrderForm.controls.Status.value || this.Status || '',
            expectedDispatchDate: formatDateDDMMYY(this.createOrderForm.controls.ShipmentDate.value || this.ShipmentDate),
            driverName: this.createOrderForm.controls.driverName.value || '',
            driverContact: this.createOrderForm.controls.driverContact.value || '',
            expectedDeliveryDate: formatDateDDMMYY(this.createOrderForm.controls.expDeliveryDate.value || this.ShipmentDate),
            transporterName: this.createOrderForm.controls.DispatchThrough.value || '',
            vehicleNumber: this.createOrderForm.controls.MotorVehicalNo.value || '',
            lrNumber: this.createOrderForm.controls.BillOfLading.value || '',
            invoiceAmount: formatCurrency(this.orderTotal),
          };

          return this.emailTemplateService.replacePlaceholders(template, templateData);
        })
      ).subscribe({
        next: (emailBody: string) => {

          const emailToId = this.resolveCustomerEmail(order);
          if (!emailToId) {
            this.loader = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Missing Email',
              detail: 'No customer email found. Please update the customer details before sending.'
            });
            return;
          }

          const emailData = {
            EmailToId: emailToId,
            EmailToName: this.resolveCustomerName(order),
            EmailSubject: `Order ${this.createOrderForm.controls.OrderNo.value || order?.SalesOrderNumber || ''
              } from ${this.companyInfo?.companyName || 'our company'}`,
            EmailBody: emailBody,
            OrderNumber: order.SalesOrderNumber,
            OrderType: 'SalesOrder',
            TenantId: tenant,
            ReportPath: this.ReportPath,
            DepartmentName: departmentName
          };

          setTimeout(() => {

            this.salesService.SendMail(emailData).subscribe({
              next: () => {
                this.loader = false;
                // this.messageService.add({
                //   severity: 'success',
                //   summary: 'Email Sent',
                //   detail: `Email sent successfully`
                // });
                this.createRecentInteractions(departmentName);
              },

              error: () => {
                this.loader = false;
                this.messageService.add({
                  severity: 'error',
                  summary: 'Failed',
                  detail: 'Email failed to send. Please try again.'
                });
              }
            });
          }, 2000);
        },

        error: () => {
          this.loader = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Template Error',
            detail: 'Email template failed to load.'
          });
        }
      });
    });
  }

  private resolveCustomerEmail(order: any): string | null {
    return (
      this.customerEmail ||
      this.selectedCustomerEmail ||
      order?.customer?.email ||
      order?.customer?.emailID1 ||
      order?.CustomerEmail ||
      order?.customerEmail ||
      order?.billToCustomer?.email ||
      order?.BillToCustomerEmail ||
      order?.shipToCustomer?.email ||
      null
    );
  }

  private resolveCustomerName(order: any): string {
    return (
      this.createOrderForm.controls.BillToCustomer.value ||
      order?.customer?.customerName ||
      order?.CustomerName ||
      this.selectedCustomerName ||
      this.createOrderForm.controls.BillToCustomerCode.value ||
      'Customer'
    );
  }

  getCompanyDetails() {
    this.administratorService.getCompanyDetails().subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          const company = data[0];
          this.companyInfo = {
            companyName: company.companyName,
            companyEmail: company.emailID1,
            companyPhone: company.mobile,
            companyWebsite: `https://${company.website?.replace(/^https?:\/\//, '')}`,
          };
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  createRecentInteractions(departmentName: string = '') {
    const nowUTC = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(nowUTC.getTime() + istOffset);
    const formData = this.createOrderForm.value;

    const appKey = departmentName ? `dept.email.${departmentName}` : 'emailid';

    this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
      next: (config: any) => {
        const fromEmail = config?.data || 'default@example.com';

        const recentInteraction: RecentInteractions = {
          sendDate: istDate,
          type: "Send Mail",
          from: fromEmail,
          to: this.customerEmail || 'default@example.com',
          subject: `Dispatch Order ${this.createOrderForm.controls.OrderNo.value || ''} ${this.createOrderForm.controls.Status.value || this.Status || ''}`,
          // subject: formData.Status || 'Order Created',
          customerNumber: formData.BillToCustomerCode ?? '',
          description: "Dispatch Order successfully placed",
          createdBy: localStorage.getItem('username') || '',
          isActive: true
        };

        this.salesService.createRecentInteractions(recentInteraction).subscribe({
          next: res => {
            console.log('Recent interaction created:', res);
          },
          error: err => console.error('Recent interaction error:', err)
        });
      },
      error: err => console.error('Recent interaction error:', err)
    });
  }

  getTermsByCustomer(CustomerCode: string) {
    this.paymentService.getTermByCustomer(CustomerCode).subscribe(
      (data: any) => {
        if (data.success) {
          const termsData = data.termsDetails
          this.createOrderForm.controls.TermsCode.setValue(termsData.paymentTermsDescription),
            this.createOrderForm.controls.PaymentTermsId.setValue(termsData.paymentTermsId)

        }
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while patch customer' });
      }
    );
  }

  // Email Functionlity Move to invoice 

  sendInvoiceEmail() {
    if (!this.sendEmailOnInvoice) {
      return;
    }

    const authString = localStorage.getItem('auth');
    if (!authString) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Auth information is missing' });
      return;
    }

    const auth = JSON.parse(authString);
    if (!auth.tenant?.tenantCode) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Tenant Code is missing' });
      return;
    }

    const tenant = auth.tenant.tenantCode;
    const formCode = 'Invoice';
    this.loader = true;

    this.getUserDepartmentName().subscribe(departmentName => {

      this.reportService.getReportName(formCode).subscribe({
        next: (report: any) => {
          this.ReportPath = report.path;
        },
        error: () => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Report not found' });
        }
      });

      this.loader = true;

      const templateCode = 'auto-invoice-creation-template';

      this.salesService.getEmailTemplate(tenant, templateCode).pipe(
        map((templateResponse: any) => {

          const template =
            templateResponse?.body ??
            templateResponse?.Body ??
            templateResponse?.templateBody ??
            templateResponse?.TemplateBody ??
            templateResponse?.emailBody ??
            templateResponse?.EmailBody;

          if (!template) {
            throw new Error('Email template body not found in response');
          }

          const templateData = {
            customerName: this.createOrderForm.controls['BillToCustomer'].value || 'Customer',
            orderNumber: this.createOrderForm.controls['OrderNo'].value || '',
            invoiceNumber: this.createOrderForm.controls['OrderNo'].value || '',
            orderDate: formatDateDDMMYY(this.createOrderForm.controls['orderDate'].value),
            invoiceDate: formatDateDDMMYY(new Date()),
            billToName: this.createOrderForm.controls['BillToCustomer'].value || 'Customer',
            shipToName: this.createOrderForm.controls['ShipToCustomer'].value || 'Customer',
            salespersonName: this.createOrderForm.controls['saleserson'].value || 'Not assigned',
            salespersonCode: this.createOrderForm.controls['SalespersonCode'].value || '',
            warehouseName: this.createOrderForm.controls['warehouse'].value || '',
            orderTotal: this.orderTotal.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }),
            totalAmount: this.orderTotal.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }),
            cgstTotal: this.CGSTtotal.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }),
            sgstTotal: this.SGSTtotal.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }),
            igstTotal: this.IGSTtotal.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }),
            salesTaxTotal: (this.CGSTtotal + this.SGSTtotal + this.IGSTtotal).toLocaleString('en-IN', { style: 'currency', currency: 'INR' }),

            currentYear: new Date().getFullYear(),
            companyName: this.companyInfo?.companyName || ' ',
            companyEmail: this.companyInfo?.companyEmail || ' ',
            companyPhone: this.companyInfo?.companyPhone || ' ',
            companyWebsite: this.companyInfo?.companyWebsite || ' ',
          };

          return this.emailTemplateService.replacePlaceholders(template, templateData);
        })
      ).subscribe({
        next: (emailBody: string) => {
          const emailToId = this.customerEmail || this.selectedCustomerEmail;

          if (!emailToId) {
            this.loader = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Missing Email',
              detail: 'No customer email found. Please update the customer details before sending.'
            });
            return;
          }

          const emailData = {
            EmailToId: emailToId,
            EmailToName: this.createOrderForm.controls['BillToCustomer'].value || 'Customer',
            EmailSubject: `Invoice ${this.createOrderForm.controls['OrderNo'].value} from ${this.companyInfo?.companyName || 'our company'}`,
            EmailBody: emailBody,
            OrderNumber: this.createOrderForm.controls['OrderNo'].value,
            OrderType: 'Invoice',
            TenantId: tenant,
            ReportPath: this.ReportPath,
            DepartmentName: departmentName
          };

          setTimeout(() => {
            this.salesService.SendMail(emailData).subscribe({
              next: () => {
                this.loader = false;
                this.createRecentInteractionsForInvoice(departmentName);
                this.messageService.add({
                  severity: 'success',
                  summary: 'Email Sent',
                  detail: 'Invoice email sent successfully.'
                });
              },
              error: (err) => {
                this.loader = false;
                this.messageService.add({
                  severity: 'error',
                  summary: 'Failed',
                  detail: 'Email failed to send. Please try again.'
                });
              }
            });
          }, 1000);
        },
        error: (err) => {
          this.loader = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Template Error',
            detail: 'Email template failed to load.'
          });
        }
      });
    });
  }

  createRecentInteractionsForInvoice(departmentName: string = '') {
    const nowUTC = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(nowUTC.getTime() + istOffset);
    const formData = this.createOrderForm.value;

    const appKey = departmentName ? `dept.email.${departmentName}` : 'emailid';

    this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
      next: (config: any) => {
        const fromEmail = config?.data || 'default@example.com';

        const recentInteraction: any = {
          sendDate: istDate,
          type: "Send Mail",
          from: fromEmail,
          to: this.customerEmail || this.selectedCustomerEmail || 'default@example.com',
          subject: `Invoice ${formData.OrderNo} - created successfully`,
          customerNumber: formData.BillToCustomerCode ?? '',
          description: `Invoice created from dispatch order successfully`,
          createdBy: localStorage.getItem('username') || '',
          isActive: true
        };

        this.salesService.createRecentInteractions(recentInteraction).subscribe({
          next: res => {
            console.log('Recent interaction created:', res);
          },
          error: err => console.error('Recent interaction error:', err)
        });
      },
      error: err => console.error('Recent interaction error:', err)
    });
  }

  getSystemConfigDataForEmail(): void {
    this.loader = true;

    const configs = [
      'emailid',
      'auto_order_email',
      'AUTO_INVOICE_EMAIL'
    ];

    const requests = configs.map(key =>
      this.inventoryService.getSystemConfigByAppKey(key)
    );

    forkJoin(requests).subscribe({
      next: (responses: any[]) => {
        responses.forEach(response => {
          switch (response?.appKeycode) {
            case 'emailid':
              this.emailFromSystemConfig = response?.data;
              break;

            case 'auto_order_email':
              this.canSendEmail = true;
              this.autoSendEmail = response?.data === 'Y';
              break;

            case 'AUTO_INVOICE_EMAIL':
              this.sendEmailOnInvoice = response?.data === 'Y';
              break;
          }
        });

        this.loader = false;
      },
      error: error => {
        console.error('Error fetching Email System Config Data:', error);
        this.loader = false;
      }
    });
  }

  gstOptions = [
    { label: 'GST0 - (0%)', value: 0 },
    { label: 'GST5 - (5%)', value: 5 },
    { label: 'GST12 - (12%)', value: 12 },
    { label: 'GST18 - (18%)', value: 18 },
    { label: 'GST28 - (28%)', value: 28 }
  ];

  calculateFreightGST() {

    const freight = Number(this.createOrderForm.get('FreightTotal')?.value) || 0;
    const rate = Number(this.createOrderForm.get('RateOnFreight')?.value) || 0;

    const gstAmount = (freight * rate) / 100;

    this.createOrderForm.patchValue({
      GSTOnFreight: Number(gstAmount.toFixed(2))
    }, { emitEvent: false });
    this.calculateOrderTotal();
  }

  getUserDepartmentName(): Observable<string> {
    const authString = localStorage.getItem('auth');
    if (!authString) return of('');

    const auth = JSON.parse(authString);
    const user = auth?.user;

    if (!user?.id) return of('');

    return this.administratorService.getUserById(user.id).pipe(
      switchMap((userData: any) => {
        const departmentId =
          userData?.departmentId;

        if (!departmentId) return of('');

        return this.porderservice.getDepartmentById(departmentId);
      }),
      map((departmentData: any) => {
        return departmentData?.departmentName;
      }),
      catchError(err => {
        console.error('Error fetching department name:', err);
        return of('');
      })
    );
  }

  updateRCMState(supplyType: string | null) {

    //console.log('Supply Type:', supplyType);

    const NON_RCM_TYPES = ['EXPORT', 'SEZ', 'B2C'];

    this.showRCM = !NON_RCM_TYPES.includes(supplyType ?? '');

    // console.log('showRCM:', this.showRCM);

    const rcm = this.createOrderForm.get('isRCM');

    if (!this.showRCM) {
      rcm?.setValue(false, { emitEvent: false });
      rcm?.disable({ emitEvent: false });
    } else {
      rcm?.enable({ emitEvent: false });
    }
  }

  private exportTypeMap: Record<string, string> = {
    EXPWOP: 'Export without payment (LUT)',
    EXPWP: 'Export with payment',
    SEZWOP: 'SEZ without payment (LUT)',
    SEZWP: 'SEZ with payment'
  };

  getExportTypeLabel(): string {

    const type = this.createOrderForm.get('expTyp')?.value ?? '';

    return this.exportTypeMap[type] || '';
  }

  isExportOrSEZ(): boolean {
    const type = this.createOrderForm.value.supplyType;
    return type === 'EXPORT' || type === 'SEZ';
  }

  setPlaceOfSupply() {

    const form = this.createOrderForm.value;

    if (form.supplyType === 'EXPORT') {
      this.createOrderForm.patchValue({
        POSDisplay: 'Other Country',
        POS: '96'
      }, { emitEvent: false });
      return;
    }

    if (form.supplyType === 'B2B') {
      this.createOrderForm.patchValue({
        POSDisplay: form.BillToCustomerState || '',
        POS: form.BillToCustomerStateCode || ''
      }, { emitEvent: false });
      return;
    }

    const posName = form.ShipToCustomerState || form.BillToCustomerState || '';
    const posCode = form.ShipToCustomerStateCode || form.BillToCustomerStateCode || '';

    this.createOrderForm.patchValue({
      POSDisplay: posName,
      POS: posCode
    }, { emitEvent: false });

    // console.log("BillToStateCode:", form.BillToCustomerStateCode);
    // console.log("ShipToStateCode:", form.ShipToCustomerStateCode);
  }

  private finishMoveToInvoice(successDetail: string): void {
    const navigateToInvoiceList = () => {
      setTimeout(() => {
        this.router.navigate(['/home/listInvoice']);
      }, 1500);
    };

    const salesOrderId = Number(this.salesOrderId ?? this.Data?.salesOrderId ?? 0);
    const username = localStorage.getItem('username') || 'System';

    if (!salesOrderId) {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: successDetail,
        life: 4000
      });
      navigateToInvoiceList();
      return;
    }

    this.loader = true;
    this.salesService.glPostSalesInvoice(salesOrderId, { createdBy: username }).subscribe({
      next: (glRes: any) => {
        this.loader = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: successDetail,
          life: 4000
        });
        this.handleSalesInvoiceGlPostResponse(glRes);
        navigateToInvoiceList();
      },
      error: (glErr: any) => {
        this.loader = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: successDetail,
          life: 4000
        });
        this.messageService.add({
          severity: 'warn',
          summary: 'GL Pending',
          detail: glErr?.error?.message ?? glErr?.error?.Message ?? 'Invoice saved but GL posting did not complete.'
        });
        navigateToInvoiceList();
      }
    });
  }

  private handleSalesInvoiceGlPostResponse(res: any): void {
    const ok = res?.success !== false && res?.Success !== false;
    const msg = (res?.message ?? res?.Message ?? '').toString();
    const entryCount = Number(res?.entriesCreated ?? res?.EntriesCreated ?? 0);

    if (ok && entryCount > 0) {
      this.messageService.add({
        severity: 'success',
        summary: 'GL Posted',
        detail: msg || `GL posted successfully (${entryCount} entries).`,
      });
      return;
    }
    if (ok && msg.toLowerCase().includes('already')) {
      this.messageService.add({ severity: 'info', summary: 'GL', detail: msg });
      return;
    }
    if (ok && (msg.toLowerCase().includes('zero') || msg.toLowerCase().includes('skipped'))) {
      this.messageService.add({ severity: 'info', summary: 'GL', detail: msg });
      return;
    }
    if (!ok) {
      this.messageService.add({
        severity: 'warn',
        summary: 'GL Pending',
        detail: msg || 'Invoice saved but GL posting did not complete.',
      });
    }
  }

  getProjectLookup() {
    this.ref = this.dialogService.open(ProjectBomLookupComponent, {
      header: 'Project List',
      width: '80%',
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.createOrderForm.patchValue({
          projectBoMId: data.projectBoMId,
          projectName: data.projectBoMName,
          projectNo: data.projectBoMCode
        });
      }
    });
  }

  clearProject() {
    this.createOrderForm.patchValue({
      projectBoMId: null,
      projectName: '',
      projectNo: ''
    });
  }

  currentFinancialYear: any;

  loadCurrentFinancialYear() {
    this.salesService.getCurrentFinancialYear().subscribe({
      next: (response: any) => {
        //console.log(response.data.fyName);

        if (!response.data) {

          this.messageService.add({
            severity: 'error',
            summary: 'Financial Year',
            // detail: 'No open Financial Year found for current date.'
            detail: 'No Open Financial Year is available for the current date. Please contact your administrator.'
          });

          return;
        }

        this.currentFinancialYear = response.data;

        this.createOrderForm.patchValue({
          FinancialYearId: this.currentFinancialYear.fyId
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No open Financial Year found.'
        });
      }
    });
  }

  validateFinancialYear(): boolean {

    const orderDate = this.createOrderForm.controls.orderDate.value;
    const requestedDate = this.createOrderForm.controls.requestedDate.value;

    if (!orderDate) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Order Date is required.'
      });
      return false;
    }

    if (!requestedDate) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Requested Date is required.'
      });
      return false;
    }

    const fy = this.currentFinancialYear;

    if (!fy) {
      this.messageService.add({
        severity: 'error',
        summary: 'Financial Year',
        detail: 'No active Financial Year found.'
      });
      return false;
    }

    // Locked FY
    if (fy.status === 'Locked') {
      this.messageService.add({
        severity: 'error',
        summary: 'Locked Financial Year',
        detail: `Financial Year ${fy.fyName} is Locked.`
      });
      return false;
    }

    // Closed FY
    if (fy.status === 'Closed') {
      this.messageService.add({
        severity: 'error',
        summary: 'Closed Financial Year',
        detail: `Financial Year ${fy.fyName} is Closed.`
      });
      return false;
    }

    const startDate = new Date(fy.startDate);
    const endDate = new Date(fy.endDate);

    const order = new Date(orderDate);
    const requested = new Date(requestedDate);

    // Order Date validation
    if (order < startDate || order > endDate) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Order Date',
        detail: `Please select an Order Date within the Financial Year (${this.formatDate(startDate)} to ${this.formatDate(endDate)}).`
      });
      return false;
    }

    // Requested Date validation
    if (requested < startDate || requested > endDate) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Requested Date',
        detail: `Please select a Requested Date within the Financial Year (${this.formatDate(startDate)} to ${this.formatDate(endDate)}).`
      });
      return false;
    }

    return true;
  }

  formatDate(date: Date): string {

    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });

  }

  onTransactionDateChange(date: Date, transaction: string) {
    // if (this.isInitializing) {
    //   return;
    // }
    if (!date) {
      this.currentFinancialYear = null;

      this.createOrderForm.patchValue({
        FinancialYearId: null
      });

      return;
    }

    this.salesService.getFinancialYearByDate(date).subscribe({
      next: (response: any) => {
        // console.log("Financial Year Response:", response);
        if (!response.success || !response.data) {

          this.currentFinancialYear = null;

          this.createOrderForm.patchValue({
            FinancialYearId: null
          });

          this.messageService.add({
            severity: 'error',
            summary: 'Financial Year',
            detail: `No Open Financial Year found for the selected ${transaction} date.`
          });

          return;
        }

        this.currentFinancialYear = response.data;

        this.createOrderForm.patchValue({
          FinancialYearId: response.data.fyId
        });
      },

      error: () => {

        this.currentFinancialYear = null;

        this.createOrderForm.patchValue({
          FinancialYearId: null
        });

        this.messageService.add({
          severity: 'error',
          summary: 'Financial Year',
          detail: 'Unable to fetch Financial Year.'
        });
      }
    });
  }


  private subscribeFinancialYearChanges() {

    this.createOrderForm.get('orderDate')?.valueChanges.subscribe(date => {

      //if (this.isInitializing) return;

      if (date instanceof Date) {
        this.onTransactionDateChange(date, "Order");
      }
    });

    this.createOrderForm.get('requestedDate')?.valueChanges.subscribe(date => {

      // if (this.isInitializing) return;

      if (date instanceof Date) {
        this.onTransactionDateChange(date, "Requested");
      }
    });

  }


}